/**
 * Configurador de suscripción Cafeshi.
 *
 * Tipos y tamaños vienen de BLOQUES de la sección (editor de temas):
 *  - bloque "type": { id, name, hasOrigins, sizes:[valores] }
 *  - bloque "size": mapa por valor { value, count, label, desc, price, image, popular }
 *
 * State: { route, type (id de bloque), proceso[], roasters[], qty, freq, origins[], box[] }.
 *
 * Dos rutas, distintos pasos:
 *  - guided: type → qty → search → result. La caja la montamos nosotros; el
 *    cliente solo puede cambiar cafés sueltos ya en el resultado.
 *  - expert: type → proceso → qty → origins → roaster → search → result.
 */
(function () {
  var root = document.getElementById('csb-root');
  if (!root) return;

  // Modo interno de diagnóstico. No altera la experiencia normal y solo se
  // activa cuando la URL incluye ?debug, ?debug=1 o ?debug=true.
  var DEBUG_MODE = false;
  var SURCHARGE_DEMO = false;
  try {
    var debugParams = new URLSearchParams(window.location.search);
    var debugValue = String(debugParams.get('debug') || '').toLowerCase();
    DEBUG_MODE = debugParams.has('debug') && ['0', 'false', 'off'].indexOf(debugValue) < 0;
    var surchargeDemoValue = String(debugParams.get('demo_surcharge') || '').toLowerCase();
    SURCHARGE_DEMO = ['1', 'true', 'on'].indexOf(surchargeDemoValue) >= 0;
  } catch (e) { /* no-op */ }
  if (DEBUG_MODE) {
    root.classList.add('is-debug');
    var debugBadge = document.createElement('div');
    debugBadge.className = 'csb-debug-mode';
    debugBadge.textContent = 'DEBUG · DATOS INTERNOS';
    debugBadge.setAttribute('role', 'status');
    root.appendChild(debugBadge);
  }

  // ---- Config (editor) ----
  var CFG = {
    defaultOrigins: ['Colombia', 'Ethiopia', 'Peru'], searchDuration: 4400,
    freqHelp: { mensual: 'Recibes y se renueva cada mes, el mismo día.', bimestral: 'Recibes tu caja cada 2 meses. Un envío menos, para quien va sin prisa.' },
    freqCadence: { mensual: 'cada mes', bimestral: 'cada 2 meses' },
    cro: { badgePopular: 'Más popular', showPerUnit: true, perUnitSuffix: 'la taza', looseRef: 0, minDiscount: 5, shipValue: 3.95, benefits: [] },
    sizes: {}
  };
  try {
    var cfgEl = document.getElementById('csb-config');
    if (cfgEl) {
      var parsed = JSON.parse(cfgEl.textContent);
      // Todo lo que venga del editor entra tal cual; así una etiqueta nueva en el
      // schema no obliga a tocar también esta lista.
      Object.keys(parsed).forEach(function (k) { if (parsed[k] != null) CFG[k] = parsed[k]; });
      CFG.defaultOrigins = (CFG.defaultOrigins || []).map(function (s) { return String(s).trim(); }).filter(Boolean);
      if (!CFG.defaultOrigins.length) CFG.defaultOrigins = ['Colombia', 'Ethiopia', 'Peru'];
      if (!CFG.searchDuration) CFG.searchDuration = 4400;
    }
  } catch (e) { /* defaults */ }

  // ---- Datos de suscripción para el carrito (variantes + selling plans de Seal) ----
  var SUB = { plans: [], variants: {}, surchargeVariants: {} };
  try {
    var subEl = document.getElementById('csb-sub-data');
    if (subEl) {
      var sp = JSON.parse(subEl.textContent);
      SUB.plans = sp.plans || [];
      SUB.variants = sp.variants || {};
      SUB.surchargeVariants = sp.surchargeVariants || {};
    }
  } catch (e) { /* no-op */ }
  function sizeLabel(v) { var s = sizeOf(v); return s ? (s.label || '') : ''; }
  function isKiloSelection() { return st.qty === '1kg'; }
  function setPendingContent(element) {
    if (!element) return;
    var message = CFG.pendingMessage || '';
    element.textContent = '';
    if (!CFG.pendingLinkLabel || !CFG.pendingLinkUrl || message.indexOf(CFG.pendingLinkLabel) < 0) {
      element.textContent = message;
      return;
    }
    var linkIndex = message.indexOf(CFG.pendingLinkLabel);
    element.appendChild(document.createTextNode(message.slice(0, linkIndex)));
    var link = document.createElement('a');
    link.href = CFG.pendingLinkUrl;
    link.textContent = CFG.pendingLinkLabel;
    element.appendChild(link);
    element.appendChild(document.createTextNode(message.slice(linkIndex + CFG.pendingLinkLabel.length)));
  }
  function renderPendingCard(container) {
    if (!container) return;
    var kicker = CFG.pendingKicker
      ? '<p class="csb-stock-card__kicker">' + esc(CFG.pendingKicker) + '</p>'
      : '';
    var title = CFG.pendingTitle
      ? '<h3 class="csb-stock-card__title" id="csb-stock-card-title">' + esc(CFG.pendingTitle) + '</h3>'
      : '';
    var message = CFG.pendingMessage
      ? '<p class="csb-stock-card__copy">' + esc(CFG.pendingMessage) + '</p>'
      : '';
    var eta = CFG.pendingEta
      ? '<p class="csb-stock-card__eta"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5"></circle><path d="M12 7.5v5l3 1.8"></path></svg><span>' + esc(CFG.pendingEta) + '</span></p>'
      : '';
    var offer = CFG.pendingOffer
      ? '<p class="csb-stock-card__offer-copy">' + esc(CFG.pendingOffer) + '</p>'
      : '';
    var link = CFG.pendingLinkLabel && CFG.pendingLinkUrl
      ? '<a class="csb-stock-card__link" href="' + esc(CFG.pendingLinkUrl) + '"><span>' + esc(CFG.pendingLinkLabel) + '</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6"></path></svg></a>'
      : '';
    var offerRow = offer || link
      ? '<div class="csb-stock-card__offer">' + offer + link + '</div>'
      : '';
    var card = document.createElement('article');
    card.className = 'csb-stock-card';
    card.setAttribute('role', 'status');
    if (CFG.pendingTitle) card.setAttribute('aria-labelledby', 'csb-stock-card-title');
    card.innerHTML = '<div class="csb-stock-card__body">' + kicker + title + message + eta + offerRow + '</div>';
    container.appendChild(card);
  }
  function subscriptionVariantId() {
    var visibleType = typeName(st.type);
    var typeLabels = [visibleType];
    var normalizedType = String(visibleType || '').toLowerCase();
    if (normalizedType.indexOf('mezcla') >= 0) typeLabels.push('Mezcla');
    else if (normalizedType.indexOf('espresso') >= 0 || normalizedType.indexOf('moka') >= 0) typeLabels.push('Espresso');
    else if (normalizedType.indexOf('filtro') >= 0) typeLabels.push('Filtro');
    else if (normalizedType.indexOf('super') >= 0) typeLabels.push('Superautomática');

    var count = sizeCount(st.qty);
    var sizeLabels = [sizeLabel(st.qty)];
    if (count === 1) sizeLabels.push('1 kg', '1kg');
    else sizeLabels.push(count + ' cafés', count + ' bolsas');

    for (var i = 0; i < typeLabels.length; i++) {
      for (var j = 0; j < sizeLabels.length; j++) {
        var variantId = SUB.variants[typeLabels[i] + '|' + sizeLabels[j]];
        if (variantId) return variantId;
      }
    }
    if (normalizedType.indexOf('super') >= 0 && !isKiloSelection()) {
      return SUB.variants['Superautomática|1 kg'] || SUB.variants['Superautomática|1kg'] || null;
    }
    return null;
  }
  // La cadencia NO se deduce del nombre del plan: el comerciante lo escribe a mano en
  // Seal y sale cosas como "2 month subscription", donde cualquier match por texto es
  // una lotería (y confundir mensual con bimestral es cobrar de más o de menos). Se lee
  // de las opciones del selling plan, que Seal rellena con la cadencia real:
  // "month" -> 1, "2 months" -> 2. El nombre queda solo de respaldo.
  function planInterval(pl) {
    var opts = (pl && pl.options) || [];
    for (var i = 0; i < opts.length; i++) {
      var v = String((opts[i] && opts[i].value) || '').toLowerCase();
      if (v.indexOf('month') < 0 && v.indexOf('mes') < 0) continue;
      var m = v.match(/(\d+)/);
      return m ? parseInt(m[1], 10) : 1;
    }
    var n = String((pl && pl.name) || '').toLowerCase();
    if (/bimestr|cada\s*2|every\s*2|2\s*(mes|month)/.test(n)) return 2;
    if (/mensual|month|\bmes\b/.test(n)) return 1;
    return 0;
  }
  // Sin coincidencia NO se devuelve un plan cualquiera: mejor que el botón avise a que
  // cobre una cadencia que el cliente no ha elegido.
  function pickPlan(freq) {
    var plans = SUB.plans || []; if (!plans.length) return null;
    var want = freq === 'bimestral' ? 2 : 1;
    for (var i = 0; i < plans.length; i++) if (planInterval(plans[i]) === want) return plans[i].id;
    return null;
  }

  // ---- Datos derivados de los bloques ----
  // Los TIPOS se leen de las propias tarjetas (DOM): así nunca hay desajuste
  // entre el markup y la lógica aunque se sirvan versiones distintas.
  var typeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-type]'));
  var TYPES = typeBtns.map(function (b) {
    return {
      id: b.getAttribute('data-type'),
      name: b.getAttribute('data-name') || '',
      // Nombre comercial de la línea (Cafeshi Kaori, Cafeshi Espresso…). Es lo
      // que ve el cliente en el resultado; el "name" es el método a secas.
      commercial: b.getAttribute('data-commercial') || '',
      description: b.getAttribute('data-description') || '',
      hasOrigins: b.getAttribute('data-has-origins') !== 'false',
      sizes: (b.getAttribute('data-sizes') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean)
    };
  });
  var SIZES = CFG.sizes || {};

  function typeById(id) { for (var i = 0; i < TYPES.length; i++) { if (TYPES[i].id === id) return TYPES[i]; } return null; }
  function sizeOf(v) { return SIZES[v] || null; }
  function sizeCount(v) { var s = sizeOf(v); return s ? (parseInt(s.count, 10) || 1) : 1; }
  function parsePrice(s) { return parseFloat(String(s).replace(',', '.')) || 0; }
  function money(n) { return (n % 1 === 0 ? String(n) : n.toFixed(2).replace('.', ',')) + ' €'; }
  function formatEur(n) { return n.toFixed(2).replace('.', ',') + ' €'; }
  // El precio SIEMPRE se dice con su cadencia real: en bimestral son 52 € cada
  // 2 meses, no 52 € al mes. Un único sitio para no volver a descuadrarlo.
  function cadence() { return (CFG.freqCadence && CFG.freqCadence[st.freq]) || 'cada mes'; }
  function priceSuffix() { return ' ' + cadence(); }

  // Ahorro REAL de la caja vs comprar esos cafés sueltos (precio medio suelto).
  function looseTotal(count) { var r = parseFloat((CFG.cro || {}).looseRef) || 0; return r > 0 ? r * count : 0; }
  function realDiscount(price, count) {
    var lt = looseTotal(count);
    if (lt <= price || price <= 0) return 0;
    return Math.round((1 - price / lt) * 100);
  }
  function minDiscount() { return parseInt((CFG.cro || {}).minDiscount, 10) || 0; }


  // Fechas (en el navegador del cliente)
  function addMonths(d, m) {
    var x = new Date(d.getTime());
    var day = x.getDate();
    x.setMonth(x.getMonth() + m);
    if (x.getDate() < day) x.setDate(0); // ajusta fin de mes (p. ej. 31 → 28/30)
    return x;
  }
  function fmtDate(d) {
    try { return d.toLocaleDateString('es-ES', { day: 'numeric', month: 'long' }); }
    catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); }
  }

  var CHK_CARD = '<span class="csb-card-check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M5 12l5 5 9-11"/></svg></span>';
  // Mismo chevrón que los acordeones del resultado (se pintan desde Liquid).
  var CHEVRON = '<svg class="csb-faq__chev" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';
  var SACHET = '<svg viewBox="0 0 24 32" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"><path d="M5 9h14l-1.2 20H6.2L5 9Z"/><path d="M5 9l2-4h10l2 4"/><path d="M8.5 15h7"/></svg>';
  var BENEFIT_ICONS = [
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.5-3 7.6-7 9-4-1.4-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>',
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>'
  ];
  var BENEFIT_FALLBACK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M8.5 12l2.2 2.2L16 9"/></svg>';

  // ---- Orígenes (Paso 3) ----
  // Fallback si no hay datos en vivo (editor sin colección de cafés).
  var FALLBACK_ORIGINS = {
    'Colombia': { es: 'Colombia', c: ['The Fix · El Recuerdo', 'Kima · Bourbon Ají', 'Kima · Sidra Red Honey', 'Kima · Sudan Rume', 'Nubra · Misak Lavado', 'Brewing Dealers · Chimba', 'Fève · Bourbon Orange', 'The Fix · Descafeinado'] },
    'Ethiopia': { es: 'Etiopía', c: ['Fève · Kachara', 'Kima · Shatawene Lavado', 'Kima · Natural Tulise', 'Mundo Novo · Bette Buna'] },
    'Peru': { es: 'Perú', c: ['Amauta · Los Morales Pacamara', 'The Fix · Querofinca', 'Amauta · Las Orquídeas Gesha', 'Amauta · Juan Heredia', 'Nomad · Timbuyacu', 'Amauta · Agua Colorada'] },
    'Kenya': { es: 'Kenia', c: ['The Fix · Kenya AA Thiririka', 'DAK · Cranberry Lane'] },
    'Costa Rica': { es: 'Costa Rica', c: ['Brewing Dealers · Guaro', 'Fève · Monte Brisas', 'DAK · Orange County'] },
    'Bolivia': { es: 'Bolivia', c: ['Ineffable · ATOQ'] },
    'Mexico': { es: 'México', c: ['Fève · Mexique Decaf'] },
    'Indonesia': { es: 'Indonesia', c: ['Nubra · Tuang Natural Anaeróbico'] },
    'Tanzania': { es: 'Tanzania', c: ['DAK · Yellow Mellow'] },
    'Honduras': { es: 'Honduras', c: ['DAK · Plum Marmalade'] },
    'Ecuador': { es: 'Ecuador', c: ['The Fix · Ecuador Alambi'] }
  };

  // Nombre del origen (ES, como está en custom.origenes) → país del world-atlas (EN).
  var ES2EN = {
    'Colombia': 'Colombia', 'Etiopía': 'Ethiopia', 'Etiopia': 'Ethiopia', 'Perú': 'Peru', 'Peru': 'Peru',
    'Kenia': 'Kenya', 'Kenya': 'Kenya', 'Costa Rica': 'Costa Rica', 'Bolivia': 'Bolivia',
    'México': 'Mexico', 'Mexico': 'Mexico', 'Indonesia': 'Indonesia', 'Tanzania': 'Tanzania',
    'Honduras': 'Honduras', 'Ecuador': 'Ecuador', 'Brasil': 'Brazil', 'Brazil': 'Brazil',
    'Guatemala': 'Guatemala', 'Ruanda': 'Rwanda', 'Rwanda': 'Rwanda', 'El Salvador': 'El Salvador',
    'Panamá': 'Panama', 'Panama': 'Panama', 'Nicaragua': 'Nicaragua', 'Yemen': 'Yemen',
    'India': 'India', 'Uganda': 'Uganda', 'Burundi': 'Burundi', 'Vietnam': 'Vietnam',
    'República Dominicana': 'Dominican Rep.', 'China': 'China'
  };

  // País del mapa (EN) → código ISO-3166 alpha-2 para la bandera (flagcdn.com).
  var FLAG_ISO = {
    'Colombia': 'co', 'Ethiopia': 'et', 'Peru': 'pe', 'Kenya': 'ke', 'Costa Rica': 'cr', 'Bolivia': 'bo',
    'Mexico': 'mx', 'Indonesia': 'id', 'Tanzania': 'tz', 'Honduras': 'hn', 'Ecuador': 'ec', 'Brazil': 'br',
    'Guatemala': 'gt', 'Rwanda': 'rw', 'El Salvador': 'sv', 'Panama': 'pa', 'Nicaragua': 'ni', 'Yemen': 'ye',
    'India': 'in', 'Uganda': 'ug', 'Burundi': 'bi', 'Vietnam': 'vn', 'Dominican Rep.': 'do', 'China': 'cn'
  };
  function flagImg(k) {
    var iso = FLAG_ISO[k];
    return iso ? '<img class="csb-flag" src="https://flagcdn.com/' + iso + '.svg" alt="" width="20" height="14" loading="lazy">' : '';
  }

  // Un café puede ser string (fallback) u objeto {t,img,url} (datos en vivo).
  function cName(x) { return (x && typeof x === 'object') ? (x.t || '') : (x || ''); }
  function cHandle(x) { return (x && typeof x === 'object') ? (x.h || '') : ''; }
  function cVariantId(x) { return (x && typeof x === 'object') ? (x.vid || '') : ''; }
  function cImg(x) { return (x && typeof x === 'object') ? (x.img || '') : ''; }
  function cUrl(x) { return (x && typeof x === 'object') ? (x.url || '') : ''; }
  function cAvail(x) {
    if (!(x && typeof x === 'object')) return !catalogEligibilityReady;
    return x.a !== false && (!catalogEligibilityReady || x.e !== false);
  }
  function cProceso(x) { return (x && typeof x === 'object') ? (x.pr || '') : ''; }
  // Proceso normalizado ({Lavado,Natural,Honey}); si falta, cae al proceso crudo.
  function cProcNorm(x) { return (x && typeof x === 'object') ? (x.pn || x.pr || '') : ''; }
  function cVarietal(x) { return (x && typeof x === 'object') ? (x.va || '') : ''; }
  function cPrice(x) { return (x && typeof x === 'object') ? (parseFloat(x.pp) || 0) : 0; }
  function cWeight(x) { return (x && typeof x === 'object') ? (parseInt(x.w, 10) || 0) : 0; }
  function cRoastDate(x) { return (x && typeof x === 'object') ? (x.rd || '') : ''; }
  function cDebug(x) { return (x && typeof x === 'object' && x.dbg) ? x.dbg : null; }
  var catalogEligibilityReady = false;
  // Tostador: metacampo marca; si falta, el prefijo del título antes de " - ".
  function cRoaster(x) {
    if (x && typeof x === 'object') {
      if (x.ma) return x.ma;
      var t = x.t || ''; var i = t.indexOf(' - '); if (i < 0) i = t.indexOf(' – ');
      return i > 0 ? t.slice(0, i).trim() : '';
    }
    return '';
  }
  // Valor especial del paso proceso: "elegid vosotros" (no filtra por proceso).
  var SURPRISE = 'Sorpresa';

  // Regla de composición Cafeshi: la caja se monta sobre lavados (el perfil de
  // diario) y el natural entra como contraste, uno por cada tres cafés, nunca
  // más. Es la regla que pidió Jose Manuel: "natural solamente uno".
  function isNatural(c) { return (cProcNorm(c) || '').toLowerCase().indexOf('natural') >= 0; }
  // Uno por cada tres: 3 cafés → 1, 4 → 1, 6 → 2. Por debajo de 3 no hay regla
  // que aplicar (el kilo de la superautomática es un solo café, no una caja).
  function naturalQuota(count) { return count < 3 ? -1 : Math.floor(count / 3); }

  // "A, B y C"
  function humanList(arr) {
    arr = arr.filter(Boolean);
    if (arr.length <= 1) return arr[0] || '';
    return arr.slice(0, -1).join(', ') + ' y ' + arr[arr.length - 1];
  }
  function uniq(a) { var s = {}, o = []; a.forEach(function (x) { if (x && !s[x]) { s[x] = 1; o.push(x); } }); return o; }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function debugMoney(value) {
    var n = parseFloat(value);
    return n > 0 ? formatEur(n) : 'Sin dato';
  }
  function debugCoffeeHtml(coffee) {
    if (!DEBUG_MODE) return '';
    var dbg = cDebug(coffee) || {};
    var process = dbg.process || cProcNorm(coffee) || cProceso(coffee) || 'Sin dato';
    var weight = parseInt(dbg.weightGrams, 10) || cWeight(coffee);
    var stock = Number.isFinite(Number(dbg.stock)) ? String(Math.trunc(Number(dbg.stock))) : 'Sin dato';
    var rows = [
      ['Proceso', process],
      ['Peso', weight > 0 ? weight + ' g' : 'Sin dato'],
      ['Coste', debugMoney(dbg.cogs)],
      ['PVP', debugMoney(dbg.price || cPrice(coffee))],
      ['Stock', stock],
      ['Tueste', dbg.roastDate || cRoastDate(coffee) || 'Sin dato'],
      ['Tostador', dbg.vendor || cRoaster(coffee) || 'Sin dato']
    ];
    return '<span class="csb-debug-card" aria-label="Datos internos del café">' + rows.map(function (row) {
      return '<span class="csb-debug-card__row"><span>' + esc(row[0]) + '</span><strong>' + esc(row[1]) + '</strong></span>';
    }).join('') + '</span>';
  }

  // Construye los orígenes desde la colección (metacampo custom.origenes) agrupando por país.
  function buildOrigins() {
    try {
      var el = document.getElementById('csb-origins-data');
      if (!el) return null;
      var flat = JSON.parse(el.textContent || '[]');
      if (!flat || !flat.length) return null;
      var byEn = {};
      flat.forEach(function (it) {
        var es = String(it.o || '').trim(); if (!es) return;
        var en = ES2EN[es] || es;
        if (!byEn[en]) byEn[en] = { es: es, c: [], seen: {} };
        if (it.t && !byEn[en].seen[it.t]) { byEn[en].seen[it.t] = 1; byEn[en].c.push({ h: it.h || '', t: it.t, img: it.img || '', url: it.url || '', a: it.a !== false, pr: it.pr || '', pn: it.pn || '', va: it.va || '', ma: it.ma || '', pp: parseFloat(it.pp) || 0, w: parseInt(it.w, 10) || 0, rd: it.rd || '', e: true }); }
      });
      return Object.keys(byEn).length ? byEn : null;
    } catch (e) { return null; }
  }

  var ORIGINS = buildOrigins() || FALLBACK_ORIGINS;
  var ALIAS = { 'United Republic of Tanzania': 'Tanzania' };
  // Nº de orígenes a elegir: 3, o menos si no hay tantos disponibles.
  var REQUIRED = Math.min(3, Object.keys(ORIGINS).length) || 1;
  // Cafés de un origen con stock (y aptos para la suscripción cuando el servidor ya respondió).
  function availCount(k) { return ORIGINS[k] ? ORIGINS[k].c.filter(cAvail).length : 0; }
  var DEFAULTS = CFG.defaultOrigins.filter(function (k) { return ORIGINS[k] && availCount(k) > 0; });
  Object.keys(ORIGINS).forEach(function (k) { if (DEFAULTS.length < REQUIRED && DEFAULTS.indexOf(k) < 0 && availCount(k) > 0) DEFAULTS.push(k); });
  DEFAULTS = DEFAULTS.slice(0, REQUIRED);
  function keyOf(n) { if (ORIGINS[n]) return n; if (ALIAS[n] && ORIGINS[ALIAS[n]]) return ALIAS[n]; return null; }

  function blankState() { return { route: null, type: null, proceso: [], roasters: [], qty: null, freq: 'mensual', origins: [], box: null, boxSig: null }; }
  var st = blankState();
  var serverMetrics = null;
  var serverBoxReady = false;
  var assignmentPending = false;
  var serverBoxError = '';
  var boxValidationPending = false;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (id) { return document.getElementById('csb-' + id); };

  // ---- Persistencia ----
  var LS_KEY = 'cafeshi-sub-builder-v3';
  var currentStep = 'type';
  function persist() { try { localStorage.setItem(LS_KEY, JSON.stringify({ st: st, step: currentStep })); } catch (e) { /* no-op */ } }
  function readSaved() { try { return JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) { return null; } }
  function clearSaved() { try { localStorage.removeItem(LS_KEY); } catch (e) { /* no-op */ } }

  function typeName(id) { var t = typeById(id); return t ? t.name : ''; }
  // Cae al método si la línea no tiene nombre comercial cargado.
  function lineName(id) { var t = typeById(id); return (t && t.commercial) || (t ? t.name : ''); }

  // Tamaño preseleccionado: el marcado "popular" del tipo, si no el del medio.
  function defaultQty(t) {
    if (!t || !t.sizes.length) return null;
    for (var i = 0; i < t.sizes.length; i++) { var s = sizeOf(t.sizes[i]); if (s && s.popular) return t.sizes[i]; }
    return t.sizes[Math.floor(t.sizes.length / 2)];
  }
  function firstStepAfterType(t) {
    if (st.route === 'expert') return 'proceso';
    if (t.sizes.length > 1) return 'qty';
    return 'search';
  }

  // Guiada: método → tamaño → resultado. La caja la montamos nosotros, sin más preguntas.
  // Experta: método → proceso → tamaño → orígenes (mapa) → tostador, de más a menos peso.
  function flow() {
    var t = typeById(st.type);
    var steps = ['type'];
    if (st.route === 'expert') steps.push('proceso');
    if (t && t.sizes.length > 1) steps.push('qty');
    if (st.route === 'expert' && t && t.hasOrigins) steps.push('origins', 'roaster');
    steps.push('search', 'result');
    return steps;
  }
  var CHOICE_STEPS = { type: 1, proceso: 1, qty: 1, origins: 1, roaster: 1 };
  function choiceSteps() { return flow().filter(function (s) { return CHOICE_STEPS[s]; }); }

  // Solo se desplaza cuando el cliente avanza de paso. En la primera pintada NO:
  // encima del configurador va la landing, y arrancar bajando hasta aquí se la
  // salta (y con progreso guardado dejaba al cliente en mitad del flujo sin verla).
  var booted = false;
  function maybeScroll() {
    if (!booted) return;
    var rect = root.getBoundingClientRect();
    if (rect.top < 0 || rect.top > window.innerHeight * 0.4) {
      root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
  }

  function show(step) {
    ['entry', 'type', 'proceso', 'qty', 'origins', 'roaster', 'search', 'result'].forEach(function (s) {
      var el = $('s-' + s); if (el) el.classList.toggle('is-on', s === step);
    });
    currentStep = step;
    renderStepper(step);
    // Sin barra de pasos en la entrada ni en el resultado (flujo no empezado / completo).
    var stp = $('stepper'); if (stp) stp.style.display = (step === 'entry' || step === 'result') ? 'none' : '';
    if (step === 'type') applyRouteCopy();
    // El "atrás" del paso tamaño vuelve a proceso (experta) o directo al método (guiada).
    // El "atrás" del resultado vuelve al último paso de elección de la ruta.
    if (step === 'result') { var rb = $('result-back'), cs0 = choiceSteps(); if (rb) { rb.setAttribute('data-back', cs0[cs0.length - 1] || 'type'); rb.hidden = !cs0.length; } }
    if (step === 'qty') { var qb = $('qty-back'); if (qb) qb.setAttribute('data-back', st.route === 'expert' ? 'proceso' : 'type'); }
    // Numera el antetítulo "Paso N" según la posición real en la ruta (evita repetir "Paso 2").
    (function () {
      var cs = choiceSteps(), idx = cs.indexOf(step);
      if (idx >= 1) {
        var scr = $('s-' + step), eb = scr && scr.querySelector('.csb-eyebrow');
        if (eb && /^\s*paso\b/i.test(eb.textContent)) eb.textContent = 'Paso ' + (idx + 1);
      }
    })();
    maybeScroll();
    if (step === 'search') runSearch();
    if (step === 'result') renderResult();
    persist();
  }

  // Copy del Paso 1 según la ruta (guiada = como experiencia; experta = término directo).
  function applyRouteCopy() {
    var guided = st.route === 'guided';
    var eb = $('type-eyebrow'), h = $('type-heading'), sub = $('type-sub');
    if (h) h.textContent = guided ? (CFG.guidedTypeHeading || '¿Cómo preparas el café en casa?') : (CFG.expertTypeHeading || 'Elige tu método');
    if (sub) sub.textContent = guided ? (CFG.guidedTypeSub || 'Elige tu cafetera. Nosotros nos encargamos del resto.') : (CFG.expertTypeSub || 'La puntuación no lo es todo: catamos cada lote y seleccionamos para ti. Tú eliges el perfil.');
    if (eb) eb.textContent = guided ? (CFG.guidedTypeEyebrow || 'Paso 1 · Ruta guiada') : (CFG.expertTypeEyebrow || 'Paso 1 · Ruta experta');
  }
  function renderStepper(step) {
    var steps = choiceSteps(); var box = $('stepper'); box.innerHTML = '';
    var idx = steps.indexOf(step);
    var cur = (step === 'search' || step === 'result') ? steps.length : idx;
    steps.forEach(function (s, i) {
      var seg = document.createElement('div');
      seg.className = 'csb-seg' + (i < cur ? ' is-done' : (i === cur ? ' is-active' : ''));
      seg.innerHTML = '<i></i>';
      box.appendChild(seg);
    });
  }

  // ---- Paso 1: tipos (tarjetas estáticas = bloques) ----
  function paintTypes() {
    typeBtns.forEach(function (b) {
      var on = b.getAttribute('data-type') === st.type;
      b.classList.toggle('is-sel', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function setupTypes() {
    typeBtns.forEach(function (b) {
      b.onclick = function () {
        var id = b.getAttribute('data-type');
        var t = typeById(id);
        if (!t) return;
        if (st.type !== id) catalogEligibilityReady = false; st.type = id; st.qty = defaultQty(t); st.freq = 'mensual'; st.origins = []; st.box = null;
        paintTypes();
        var ns = firstStepAfterType(t);
        if (ns === 'proceso') paintProceso();
        if (ns === 'qty') renderQty();
        show(ns);
      };
    });
  }

  // ---- Ruta experta · Paso tostador (opcional: sin selección = sin filtro) ----
  // Los tostadores salen de los propios cafés (metacampo marca), no de una lista fija.
  function allRoasters() {
    var m = {};
    Object.keys(ORIGINS).forEach(function (k) {
      ORIGINS[k].c.forEach(function (c) {
        var r = cRoaster(c); if (!r) return;
        if (!m[r]) m[r] = { name: r, n: 0, avail: 0 };
        m[r].n++; if (cAvail(c)) m[r].avail++;
      });
    });
    var list = Object.keys(m).map(function (k) { return m[k]; })
      .sort(function (a, b) { return b.avail - a.avail || b.n - a.n || a.name.localeCompare(b.name); });
    // Solo los que hoy pueden entrar en una caja: ofrecer un tostador con cero
    // cafés disponibles es prometer algo que no vamos a poder mandar.
    var withStock = list.filter(function (r) { return r.avail > 0; });
    return withStock.length ? withStock : list;
  }
  function renderRoasters() {
    var box = $('roaster-opts'); if (!box) return;
    var list = allRoasters();
    box.innerHTML = '';
    if (!list.length) { box.innerHTML = '<span class="csb-hint">Aún no hay tostadores cargados. Seguimos sin filtro.</span>'; return; }
    list.forEach(function (r) {
      var on = st.roasters.indexOf(r.name) >= 0;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'csb-roaster' + (on ? ' is-sel' : '');
      b.setAttribute('role', 'listitem');
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.innerHTML = '<span class="csb-roaster__name">' + esc(r.name) + '</span>' +
        '<span class="csb-roaster__n">' + r.avail + ' ' + (r.avail === 1 ? 'café' : 'cafés') + '</span>' + CHK_CARD;
      b.onclick = function () {
        var i = st.roasters.indexOf(r.name);
        if (i >= 0) st.roasters.splice(i, 1); else st.roasters.push(r.name);
        st.box = null; renderRoasters(); persist();
      };
      box.appendChild(b);
    });
    var go = $('roaster-go');
    if (go) go.textContent = st.roasters.length ? (CFG.roasterCta || 'Buscar mis cafés') : (CFG.roasterAnyLabel || 'Me da igual, elegid vosotros');
  }
  // ¿El café es de alguno de los tostadores elegidos? Sin elección, no filtra.
  function roasterMatch(c) {
    if (!st.roasters || !st.roasters.length) return 0;
    return st.roasters.indexOf(cRoaster(c)) >= 0 ? 1 : 0;
  }

  // ---- Ruta experta · Paso proceso (multi-select, término técnico) ----
  function paintProceso() {
    root.querySelectorAll('#csb-proceso-opts .csb-proc').forEach(function (b) {
      var on = st.proceso.indexOf(b.getAttribute('data-proceso')) >= 0;
      b.classList.toggle('is-sel', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var go = $('proceso-go'); if (go) go.disabled = st.proceso.length === 0;
  }
  function setupProceso() {
    root.querySelectorAll('#csb-proceso-opts .csb-proc').forEach(function (b) {
      b.onclick = function () {
        var v = b.getAttribute('data-proceso'); var i = st.proceso.indexOf(v);
        if (i >= 0) st.proceso.splice(i, 1);
        // "Sorpréndeme" es excluyente en los dos sentidos: o eliges tú, o elegimos nosotros.
        else if (v === SURPRISE) st.proceso = [SURPRISE];
        else { st.proceso = st.proceso.filter(function (p) { return p !== SURPRISE; }); st.proceso.push(v); }
        st.box = null; paintProceso(); persist();
      };
    });
    var go = $('proceso-go');
    if (go) go.onclick = function () {
      if (!st.proceso.length) return;
      var t = typeById(st.type);
      if (t && t.sizes.length > 1) { renderQty(); show('qty'); }
      else if (t && t.hasOrigins) { renderOriginsStep(); show('origins'); }
      else show('search');
    };
  }
  function setupRoasters() {
    var go = $('roaster-go');
    if (go) go.onclick = function () { show('search'); };
  }
  // ¿El café encaja con el/los proceso(s) elegidos por el experto?
  // Con "Sorpréndeme" no filtramos: la variedad la mete la regla de composición.
  function procMatch(c) {
    if (!st.proceso || !st.proceso.length || st.proceso[0] === SURPRISE) return 0;
    var pv = (cProcNorm(c) || cProceso(c) || '').toLowerCase();
    for (var i = 0; i < st.proceso.length; i++) { if (pv.indexOf(st.proceso[i].toLowerCase()) >= 0) return 1; }
    return 0;
  }

  // ---- Paso 2: tamaños (tarjetas con sobres/ilustración) ----
  function renderQty() {
    var t = typeById(st.type); if (!t) return;
    $('qty-sub').textContent = 'Línea ' + typeName(st.type) + '. Dinos cuánto café entra en tu casa y cada cuánto quieres recibirlo.';
    var box = $('qty-opts'); box.innerHTML = '';
    var cro = CFG.cro || {};
    var minD = minDiscount();

    var benefits = (cro.benefits || []).filter(Boolean);
    var benefitsHtml = '';
    if (benefits.length) {
      benefitsHtml = '<span class="csb-qty__benefits">' + benefits.map(function (txt, i) {
        return '<span class="csb-qty__benefit">' + (BENEFIT_ICONS[i] || BENEFIT_FALLBACK) + '<span>' + txt + '</span></span>';
      }).join('') + '</span>';
    }

    t.sizes.forEach(function (v) {
      var s = sizeOf(v); if (!s) return;
      var count = parseInt(s.count, 10) || 1;
      var price = parsePrice(s.price);
      var selected = st.qty === v;

      var visual;
      if (s.image) {
        visual = '<span class="csb-qty__img"><img src="' + s.image + '" alt="' + (s.label || '') + '" loading="lazy"></span>';
      } else {
        var sachets = '';
        for (var i = 0; i < count; i++) sachets += SACHET;
        visual = '<span class="csb-qty__sachets" aria-hidden="true">' + sachets + '</span>';
      }

      var badge = (s.popular && cro.badgePopular) ? '<span class="csb-qty__badge">' + cro.badgePopular + '</span>' : '';
      // Durante el recorrido NO se enseña precio: un "desde 52 €" antes de haber
      // contado la historia espanta. Lo que se enseña es cuánto café es esto en
      // tazas, que es la unidad con la que el cliente piensa.
      var pcq = perCupInfo(s, count);
      var cups = pcq.cups > 0
        ? '<span class="csb-qty__cups"><strong>' + pcq.cups + '</strong> ' + esc(CFG.cupsSuffix || 'tazas de café') +
          (s.cupsHint ? ' <small class="csb-qty__cupshint">(' + esc(s.cupsHint) + ')</small>' : '') + '</span>'
        : '';

      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'csb-qty' + (selected ? ' is-sel' : '');
      b.setAttribute('aria-pressed', selected ? 'true' : 'false');
      b.innerHTML =
        badge +
        visual +
        '<span class="csb-qty__name">' + (s.label || '') + '</span>' +
        '<span class="csb-qty__desc">' + (s.desc || '') + '</span>' +
        cups +
        (selected ? benefitsHtml : '') +
        CHK_CARD;
      b.onclick = function () { st.qty = v; renderQty(); persist(); };
      box.appendChild(b);
    });
    renderFreq();
    renderQtyWhy();
    $('qty-go').disabled = !st.qty;
  }
  // Detalle del tamaño elegido: para quién es y por qué lo recomendamos. Va en
  // acordeón para que no compita con las tarjetas, pero que esté si se busca.
  function renderQtyWhy() {
    var box = $('qty-why'); if (!box) return;
    var s = sizeOf(st.qty);
    var items = s ? [
      { q: CFG.qtyForWhoLabel || '¿Para quién es este tamaño?', a: s.forWho },
      { q: CFG.qtyWhyLabel || '¿Por qué lo recomendamos?', a: s.why }
    ].filter(function (it) { return it.a; }) : [];
    if (!items.length) { box.innerHTML = ''; box.hidden = true; return; }
    box.hidden = false;
    box.innerHTML = items.map(function (it) {
      return '<details class="csb-faq"><summary>' + esc(it.q) + CHEVRON +
        '</summary><div class="csb-faq__a"><p>' + esc(it.a) + '</p></div></details>';
    }).join('');
  }
  function renderFreq() {
    root.querySelectorAll('#csb-freq-ctrl .csb-seg-btn').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-freq') === st.freq);
    });
    $('freq-help').textContent = CFG.freqHelp[st.freq] || '';
  }

  /* ---- Paso 3: orígenes ---- */
  var mapPaths = null, mapDrawn = false;
  // Estilo line-art Cafeshi: trazo navy fino, sin relleno en países sin café,
  // tinte navy en los que tienen café, navy sólido en los seleccionados.
  var MC = {
    na: 'transparent', naStroke: 'rgba(28, 58, 107, 0.26)',
    avail: 'rgba(28, 58, 107, 0.09)', availStroke: 'rgba(28, 58, 107, 0.5)',
    hover: 'rgba(28, 58, 107, 0.28)',
    sel: '#1c3a6b', selStroke: 'rgba(15, 30, 60, 0.9)'
  };
  function mcFill(d) { var k = keyOf(d.properties.name); if (!k || (!availCount(k) && st.origins.indexOf(k) < 0)) return MC.na; return st.origins.indexOf(k) >= 0 ? MC.sel : MC.avail; }
  function mcStroke(d) { var k = keyOf(d.properties.name); if (!k || (!availCount(k) && st.origins.indexOf(k) < 0)) return MC.naStroke; return st.origins.indexOf(k) >= 0 ? MC.selStroke : MC.availStroke; }
  function mcSW(d) { var k = keyOf(d.properties.name); if (!k) return 0.6; return st.origins.indexOf(k) >= 0 ? 1.1 : 0.8; }
  // Tooltip sobre el mapa (al hacer hover en un país), en vez de panel a la derecha.
  var tipEl = null, mapEl = null;
  function ensureTip() {
    mapEl = document.getElementById('csb-map');
    if (mapEl && !tipEl) { tipEl = document.createElement('div'); tipEl.className = 'csb-maptip'; mapEl.appendChild(tipEl); }
  }
  function tipHTML(k) {
    var o = ORIGINS[k]; var list = o.c.slice(0, 6); var extra = o.c.length - list.length;
    return '<div class="csb-ph"><span class="csb-pn">' + o.es + '</span><span class="csb-pc">' + o.c.length + ' café' + (o.c.length > 1 ? 's' : '') + '</span></div><div class="csb-tags">' + list.map(function (n) { return '<span class="csb-tag">' + cName(n) + '</span>'; }).join('') + (extra > 0 ? '<span class="csb-tag" style="border-style:dashed;">+' + extra + ' más</span>' : '') + '</div>';
  }
  function tipMove(x, y) {
    if (!tipEl || !mapEl) return;
    var mw = mapEl.clientWidth, mh = mapEl.clientHeight;
    var tw = tipEl.offsetWidth, th = tipEl.offsetHeight;
    var left = x + 16; if (left + tw > mw) left = x - tw - 16; if (left < 0) left = 4;
    var top = y + 16; if (top + th > mh) top = y - th - 16; if (top < 0) top = 4;
    tipEl.style.left = left + 'px'; tipEl.style.top = top + 'px';
  }
  function tipShow(k, x, y) {
    ensureTip(); if (!tipEl) return;
    tipEl.innerHTML = tipHTML(k);
    tipEl.classList.add('is-on');
    tipMove(x, y);
  }
  function tipHide() { if (tipEl) tipEl.classList.remove('is-on'); }
  function toggleOrigin(k) {
    var i = st.origins.indexOf(k);
    if (i >= 0) st.origins.splice(i, 1);
    else { if (!availCount(k)) return; if (st.origins.length >= REQUIRED) { warnCount(); return; } st.origins.push(k); }
    syncOrigins();
    persist();
  }
  function warnCount() {
    var c = $('sel-count'); c.classList.add('is-warn'); c.textContent = 'Máximo ' + REQUIRED + ' orígenes';
    setTimeout(function () { c.classList.remove('is-warn'); syncOrigins(); }, 1100);
  }
  function syncOrigins() {
    var n = st.origins.length;
    var cnt = $('sel-count');
    if (cnt) { cnt.textContent = n + ' de ' + REQUIRED; cnt.classList.toggle('is-done', n === REQUIRED); }
    var fill = $('progress-fill');
    if (fill) { fill.style.width = Math.min(100, Math.round((n / REQUIRED) * 100)) + '%'; fill.classList.toggle('is-done', n === REQUIRED); }
    if (mapPaths) mapPaths.attr('fill', mcFill).attr('stroke', mcStroke).attr('stroke-width', mcSW);
    renderChips(); renderSel();
    var ready = st.origins.length === REQUIRED; $('org-go').disabled = !ready;
    $('org-go').textContent = ready ? 'Continuar' : 'Elige ' + (REQUIRED - st.origins.length) + ' más';
  }
  function renderChips() {
    var box = $('org-chips'); box.innerHTML = '';
    Object.keys(ORIGINS).forEach(function (k) {
      var on = st.origins.indexOf(k) >= 0;
      var n = availCount(k);
      if (!n && !on) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'csb-chip' + (on ? ' is-on' : '');
      b.innerHTML = (on ? '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M5 12l5 5 9-11"/></svg>' : '') + ORIGINS[k].es + ' <span class="csb-n">' + n + '</span>';
      b.onclick = function () { toggleOrigin(k); };
      box.appendChild(b);
    });
  }
  function renderSel() {
    var box = $('org-sel'); box.innerHTML = '';
    if (st.origins.length === 0) { box.innerHTML = '<span class="csb-hint">Toca un país del mapa o un chip para elegir.</span>'; return; }
    st.origins.forEach(function (k) {
      var s = document.createElement('span');
      s.className = 'csb-sel-pill';
      s.innerHTML = flagImg(k) + '<span>' + ORIGINS[k].es + '</span><button type="button" aria-label="Quitar ' + ORIGINS[k].es + '"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
      s.querySelector('button').onclick = function () { toggleOrigin(k); };
      box.appendChild(s);
    });
  }
  function renderOriginsSummary() {
    var el = $('org-summary'); if (!el) return;
    var s = sizeOf(st.qty);
    if (!s) { el.textContent = ''; return; }
    var cad = cadence();
    var months = st.freq === 'bimestral' ? 2 : 1;
    var next = addMonths(new Date(), months);
    // Sin precio: aquí todavía no le hemos enseñado los cafés. El importe llega
    // en el resultado, cuando ya sabe qué se lleva.
    el.innerHTML = 'Con tu selección recibirás <strong>' + (s.label || '') + ' ' + cad +
      '</strong>. El primer cobro es hoy y se renueva el <strong>' + fmtDate(next) + '</strong>.';
  }

  // El tema solo lee la primera página de la colección (250 productos), así que
  // el stock real y apto para la suscripción lo trae la app antes de elegir orígenes.
  var originsCatalogPending = false;
  function loadOriginsCatalog() {
    if (catalogEligibilityReady || originsCatalogPending) return;
    originsCatalogPending = true;
    recommendationRequest('validate', []).then(function (payload) {
      applyServerOptions(payload.options || []);
    }).catch(function () {}).then(function () {
      originsCatalogPending = false;
      if (!catalogEligibilityReady || currentStep !== 'origins') return;
      st.origins = st.origins.filter(function (k) { return availCount(k) > 0; });
      Object.keys(ORIGINS)
        .filter(function (k) { return availCount(k) > 0 && st.origins.indexOf(k) < 0; })
        .sort(function (x, y) { return availCount(y) - availCount(x); })
        .forEach(function (k) { if (st.origins.length < REQUIRED) st.origins.push(k); });
      syncOrigins(); renderOriginsSummary(); persist();
    });
  }
  function renderOriginsStep() {
    if (st.origins.length === 0) st.origins = DEFAULTS.slice();
    ensureTip(); renderChips(); renderSel(); syncOrigins(); renderOriginsSummary();
    loadOriginsCatalog();
    if (mapDrawn) return; mapDrawn = true;
    if (typeof d3 === 'undefined' || typeof topojson === 'undefined') {
      $('map').innerHTML = '<div class="csb-hint" style="padding:14px 0;">Usa los chips de abajo para elegir tus orígenes.</div>';
      return;
    }
    var w = 880, h = 420;
    var svg = d3.select('#csb-map').append('svg').attr('viewBox', '0 0 ' + w + ' ' + h).attr('role', 'img').attr('aria-label', 'Mapamundi con orígenes de café disponibles');
    loadWorld().then(function (world) {
      var feats = topojson.feature(world, world.objects.countries).features;
      var proj = d3.geoNaturalEarth1().fitSize([w, h], { type: 'FeatureCollection', features: feats });
      var gp = d3.geoPath(proj);
      mapPaths = svg.selectAll('path').data(feats).join('path')
        .attr('d', gp)
        .attr('fill', mcFill)
        .attr('stroke', mcStroke).attr('stroke-width', mcSW)
        .attr('stroke-linejoin', 'round').attr('stroke-linecap', 'round')
        .style('cursor', function (d) { return keyOf(d.properties.name) ? 'pointer' : 'default'; })
        .on('mouseover', function (e, d) { var k = keyOf(d.properties.name); if (!k) return; var p = d3.pointer(e, mapEl); tipShow(k, p[0], p[1]); if (st.origins.indexOf(k) < 0) d3.select(this).attr('fill', MC.hover); })
        .on('mousemove', function (e, d) { var k = keyOf(d.properties.name); if (!k) return; var p = d3.pointer(e, mapEl); tipMove(p[0], p[1]); })
        .on('mouseout', function (e, d) { var k = keyOf(d.properties.name); if (!k) return; tipHide(); d3.select(this).attr('fill', mcFill); })
        .on('click', function (e, d) { var k = keyOf(d.properties.name); if (!k) return; toggleOrigin(k); });
      var leg = d3.select('#csb-map').append('div').attr('class', 'csb-legend');
      leg.html('<span class="csb-k"><span class="csb-sw" style="background:' + MC.avail + ';border:1px solid ' + MC.availStroke + '"></span>con café disponible</span><span class="csb-k"><span class="csb-sw" style="background:' + MC.sel + '"></span>seleccionado</span>');
      syncOrigins();
    }).catch(function () {
      $('map').innerHTML = '<div class="csb-hint" style="padding:14px 0;">No se pudo cargar el mapa (revisa la conexión). Usa los chips de abajo para elegir tus orígenes.</div>';
    });
  }

  /* ---- Paso 4: buscando ---- */
  function searchMessages() {
    var t = typeById(st.type);
    if (isKiloSelection()) return ['Leyendo el perfil de tu máquina', 'Cruzando catas y notas de Q-Grader', 'Buscando el kilo perfecto del mes', 'Comprobando stock y frescura', 'Afinando tu selección'];
    return ['Leyendo tus orígenes preferidos', 'Cruzando catas y notas de Q-Grader', 'Filtrando por temporada y stock', 'Equilibrando perfiles y procesos', 'Afinando tu selección'];
  }
  function runSearch() {
    var msgs = searchMessages(), mi = 0;
    var boxPromise = loadRecommendedBox();
    var fill = $('bar-fill'), pctEl = $('bar-pct'), msgEl = $('search-msg');
    msgEl.textContent = msgs[0]; fill.style.width = '0%'; pctEl.textContent = '0%';
    var total = reduce ? 900 : CFG.searchDuration;
    var start = performance.now();
    var msgTimer = setInterval(function () {
      mi++;
      if (mi < msgs.length) { msgEl.style.opacity = 0; setTimeout(function () { msgEl.textContent = msgs[mi]; msgEl.style.opacity = 1; }, 220); }
    }, total / msgs.length);
    function tick(now) {
      var t = Math.min(1, (now - start) / total);
      var eased = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      var pct = Math.round(eased * 100); fill.style.width = pct + '%'; pctEl.textContent = pct + '%';
      if (t < 1) { requestAnimationFrame(tick); }
      else {
        clearInterval(msgTimer);
        Promise.resolve(boxPromise).catch(function () { return null; }).then(function () {
          setTimeout(function () { show('result'); }, reduce ? 100 : 380);
        });
      }
    }
    requestAnimationFrame(tick);
  }

  /* ---- Paso 5: resultado ---- */
  // Todos los cafés del catálogo como pares {origen, café}.
  function allPairs() {
    var all = [];
    Object.keys(ORIGINS).forEach(function (k) { ORIGINS[k].c.forEach(function (c) { all.push({ o: k, c: c }); }); });
    return all;
  }
  function recommendationPayload(action) {
    var s = sizeOf(st.qty) || {};
    var t = typeById(st.type);
    return {
      action: action,
      mode: isKiloSelection() ? 'one-kilogram' : 'box',
      method: typeName(st.type),
      boxSize: sizeCount(st.qty),
      subscriptionPrice: parsePrice(s.price),
      process: (st.proceso || [])[0] || '',
      roasters: st.roasters || [],
      origins: (st.origins || []).map(function (k) { return ORIGINS[k] ? ORIGINS[k].es : k; }),
      shippingIncluded: CFG.isSpain === true,
      debug: DEBUG_MODE,
      selectedHandles: (st.box || []).map(function (pick) { return cHandle(pick.c); }).filter(Boolean)
    };
  }
  function recommendationRequest(action, selectedHandles) {
    var payload = recommendationPayload(action);
    if (Array.isArray(selectedHandles)) payload.selectedHandles = selectedHandles.slice();
    return fetch('/apps/cafeshi-suscripcion/recommend', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (payload) {
        if (!response.ok || !payload.ok) throw new Error(payload.error || 'No hemos podido comprobar la selección.');
        return payload;
      });
    });
  }
  function pairByHandle(handle) {
    var pairs = allPairs();
    for (var i = 0; i < pairs.length; i++) if (cHandle(pairs[i].c) === handle) return pairs[i];
    return null;
  }
  function applyServerOptions(options) {
    var byHandle = {};
    (options || []).forEach(function (coffee) {
      if (coffee && coffee.handle) byHandle[coffee.handle] = coffee;
    });
    Object.keys(ORIGINS).forEach(function (origin) {
      ORIGINS[origin].c.forEach(function (coffee) {
        var server = byHandle[cHandle(coffee)];
        coffee.e = !!server;
        if (!server) return;
        coffee.t = server.title || coffee.t || '';
        coffee.vid = server.variantId || coffee.vid || '';
        coffee.img = server.image || coffee.img || '';
        coffee.url = coffee.url || ('/products/' + server.handle);
        coffee.pr = server.process || coffee.pr || '';
        coffee.pn = server.process || coffee.pn || '';
        coffee.ma = server.vendor || coffee.ma || '';
        coffee.pp = parseFloat(server.price) || coffee.pp || 0;
        coffee.w = parseInt(server.weightGrams, 10) || coffee.w || 0;
        coffee.rd = server.roastDate || coffee.rd || '';
        coffee.dbg = server.debug || null;
      });
    });
    (options || []).forEach(function (server) {
      (server.origins || []).forEach(function (originName) {
        var origin = ES2EN[originName] || originName;
        if (!ORIGINS[origin]) ORIGINS[origin] = { es: originName, c: [], seen: {} };
        var exists = ORIGINS[origin].c.some(function (coffee) {
          return cHandle(coffee) === server.handle;
        });
        if (exists) return;
        ORIGINS[origin].c.push({
          h: server.handle,
          vid: server.variantId || '',
          t: server.title || '',
          img: server.image || '',
          url: '/products/' + server.handle,
          a: true,
          e: true,
          pr: server.process || '',
          pn: server.process || '',
          va: '',
          ma: server.vendor || '',
          pp: parseFloat(server.price) || 0,
          w: parseInt(server.weightGrams, 10) || 0,
          rd: server.roastDate || '',
          dbg: server.debug || null
        });
      });
    });
    catalogEligibilityReady = true;
  }
  function loadRecommendedBox() {
    var t = typeById(st.type);
    serverBoxReady = false;
    assignmentPending = false;
    serverMetrics = null;
    serverBoxError = '';
    return recommendationRequest('recommend').then(function (payload) {
      applyServerOptions(payload.options || payload.coffees || []);
      var box = (payload.coffees || []).map(function (coffee) { return pairByHandle(coffee.handle); }).filter(Boolean);
      assignmentPending = payload.assignmentPending === true && payload.checkoutAllowed === true && !!CFG.pendingMessage && !isKiloSelection();
      if (!assignmentPending && box.length !== sizeCount(st.qty)) throw new Error('La selección ha cambiado mientras la preparábamos.');
      st.box = box;
      st.boxSig = boxSig();
      serverMetrics = payload.metrics || null;
      serverBoxReady = true;
    }).catch(function (error) {
      assignmentPending = false;
      serverBoxError = error.message || 'No hemos podido preparar una caja válida.';
      st.box = [];
      st.boxSig = boxSig();
      throw error;
    });
  }
  function validateCurrentBox() {
    var t = typeById(st.type);
    if (isKiloSelection()) return Promise.resolve(true);
    boxValidationPending = true;
    updateSubscribeState();
    var request = assignmentPending
      ? loadRecommendedBox().then(function () { renderBox(); return { metrics: serverMetrics, options: null, assignmentPending: assignmentPending }; })
      : recommendationRequest('validate');
    return request.then(function (payload) {
      if (payload.options) applyServerOptions(payload.options);
      assignmentPending = payload.assignmentPending === true;
      serverMetrics = payload.metrics || null;
      // customerErrors trae el motivo concreto (naturales, bolsas de 200 g, valor...);
      // errors[0] es solo el aviso genérico y no le dice al cliente qué cambiar.
      var reasons = (serverMetrics && serverMetrics.customerErrors && serverMetrics.customerErrors.length)
        ? serverMetrics.customerErrors
        : ((serverMetrics && serverMetrics.errors) || []);
      serverBoxError = assignmentPending || (serverMetrics && serverMetrics.valid) ? '' : (reasons.join(' ') || 'Esta combinación no está disponible.');
      serverBoxReady = assignmentPending || !!(serverMetrics && serverMetrics.valid);
      return serverBoxReady;
    }).catch(function (error) {
      assignmentPending = false;
      serverBoxReady = false;
      serverMetrics = null;
      serverBoxError = error.message || 'No hemos podido comprobar la selección.';
      return false;
    }).then(function (valid) {
      boxValidationPending = false;
      renderDynamicCopy();
      renderResultSummary();
      updateSubscribeState();
      persist();
      return valid;
    });
  }
  // Los orígenes con los que arranca la caja de la ruta guiada: primero los que
  // Cafeshi marca por defecto, luego el resto (así la caja no sale alfabética).
  function guidedOrigins() {
    var keys = DEFAULTS.filter(function (k) { return ORIGINS[k]; });
    Object.keys(ORIGINS).forEach(function (k) { if (keys.indexOf(k) < 0) keys.push(k); });
    return keys;
  }
  // Reparto sin repetir: un café por origen y vuelta a empezar, con los
  // disponibles (y los que encajan con lo pedido) delante de cada montón.
  function roundRobin(origins, qty) {
    var pools = origins.map(function (k) {
      return ORIGINS[k].c.slice().sort(function (a, b) {
        var d = procMatch(b) - procMatch(a); if (d) return d;
        d = roasterMatch(b) - roasterMatch(a); if (d) return d;
        d = (cAvail(b) ? 1 : 0) - (cAvail(a) ? 1 : 0); if (d) return d;
        // A igualdad, el lavado primero: es la base de diario de la caja.
        return (isNatural(a) ? 1 : 0) - (isNatural(b) ? 1 : 0);
      });
    });
    var out = [], i = 0, guard = 0;
    while (out.length < qty && guard < 400) {
      if (pools.every(function (p) { return p.length === 0; })) break;
      var idx = i % origins.length, pool = pools[idx];
      if (pool.length) out.push({ o: origins[idx], c: pool.shift() });
      i++; guard++;
    }
    return out;
  }
  // Ajusta la caja a la cuota de naturales: quita los que sobran y mete el de
  // contraste si no hay ninguno. Solo toca lo justo, respetando el resto.
  function balanceProcesses(box, pool) {
    var target = naturalQuota(box.length);
    if (target < 0) return box;
    var used = {}; box.forEach(function (p) { used[pk(p)] = 1; });
    function naturals() { return box.filter(function (p) { return isNatural(p.c); }).length; }
    function free(wantNatural) {
      return pool.filter(function (p) { return !used[pk(p)] && isNatural(p.c) === wantNatural; })
        .sort(function (a, b) {
          var d = procMatch(b.c) - procMatch(a.c); if (d) return d;
          d = roasterMatch(b.c) - roasterMatch(a.c); if (d) return d;
          return (cAvail(b.c) ? 1 : 0) - (cAvail(a.c) ? 1 : 0);
        });
    }
    var washed = free(false);
    for (var i = box.length - 1; i >= 0 && naturals() > target; i--) {
      if (!isNatural(box[i].c)) continue;
      var w = washed.shift(); if (!w) break;
      delete used[pk(box[i])]; box[i] = w; used[pk(w)] = 1;
    }
    var nats = free(true);
    for (var j = box.length - 1; j >= 0 && naturals() < target; j--) {
      if (isNatural(box[j].c)) continue;
      var n = nats.shift(); if (!n) break;
      delete used[pk(box[j])]; box[j] = n; used[pk(n)] = 1;
    }
    return box;
  }
  function curate() {
    var qty = sizeCount(st.qty);
    var t = typeById(st.type);
    // Guiada: elegimos nosotros sobre todo el catálogo. Experta: sus orígenes.
    var origins = (st.route === 'expert' && t && t.hasOrigins) ? st.origins.slice() : guidedOrigins();
    origins = origins.filter(function (k) { return ORIGINS[k]; });
    if (!origins.length) origins = Object.keys(ORIGINS).slice(0, 3);

    var out = roundRobin(origins, qty);
    // Si faltan (pocos cafés disponibles), repetimos ciclando sobre todos.
    if (out.length < qty) {
      var all = [];
      origins.forEach(function (k) { ORIGINS[k].c.forEach(function (c) { all.push({ o: k, c: c }); }); });
      var j = 0;
      while (out.length < qty && all.length) { out.push(all[j % all.length]); j++; }
    }
    var pool = origins.length >= Object.keys(ORIGINS).length ? allPairs() : allPairs().filter(function (p) { return origins.indexOf(p.o) >= 0; });
    return balanceProcesses(out, pool);
  }
  // ---------- Estado y utilidades de la caja editable ----------
  function pk(p) { return p.o + '|' + cName(p.c); }
  function boxSig() { return [st.route, st.type, st.qty, (st.proceso || []).slice().sort().join(','), (st.roasters || []).slice().sort().join(','), st.origins.slice().sort().join(',')].join('|'); }
  function originCount(box) { var m = {}; box.forEach(function (p) { m[p.o] = (m[p.o] || 0) + 1; }); return m; }
  // La caja se puede tocar en las dos rutas: aunque la montemos nosotros, el
  // cliente tiene que poder cambiar un café que no le convenza.
  function isEditable() { var t = typeById(st.type); return !!(t && t.hasOrigins); }
  function boxFull() { return st.box.length >= (sizeCount(st.qty) || 1); }

  // Cafés candidatos para añadir/cambiar: los de los orígenes elegidos (experta)
  // o los de la propia caja (guiada, donde el cliente no eligió orígenes).
  function candidates() {
    var origins = st.origins.filter(function (k) { return ORIGINS[k]; });
    if (!origins.length) origins = uniq((st.box || []).map(function (p) { return p.o; })).filter(function (k) { return ORIGINS[k]; });
    if (!origins.length) origins = Object.keys(ORIGINS).slice(0, 3);
    var list = [];
    origins.forEach(function (k) { ORIGINS[k].c.forEach(function (c) { list.push({ o: k, c: c }); }); });
    return list;
  }
  // Regenera la caja solo si cambió la selección de arriba (tipo/tamaño/orígenes).
  function ensureBox(force) {
    var count = sizeCount(st.qty) || 1;
    if (assignmentPending) { st.box = []; return st.box; }
    if (!serverBoxReady || serverBoxError) {
      if (!Array.isArray(st.box)) st.box = [];
      return st.box;
    }
    if (force || !Array.isArray(st.box) || !st.box.length || st.boxSig !== boxSig()) {
      st.box = curate(); st.boxSig = boxSig();
    }
    if (st.box.length > count) st.box = st.box.slice(0, count);
    return st.box;
  }

  // ---------- Render de la caja (tarjetas + huecos) ----------
  function renderBox() {
    var count = sizeCount(st.qty) || 1, editable = isEditable();
    var cf = $('res-coffees'); cf.innerHTML = '';
    var head = $('box-head'); if (head) head.hidden = assignmentPending || !editable || !st.box.length;
    if (assignmentPending) {
      renderPendingCard(cf);
      return;
    }
    st.box.forEach(function (p, i) {
      var name = cName(p.c), img = cImg(p.c), url = cUrl(p.c);
      var oes = ORIGINS[p.o] ? ORIGINS[p.o].es : p.o;
      var media = img
        ? '<img src="' + esc(img) + '" alt="' + esc(name) + '" loading="lazy">'
        : '<span class="csb-rc__ph">' + esc(oes.slice(0, 2).toUpperCase()) + '</span>';
      // El proceso a la vista: es el dato que más dice del perfil en taza.
      var proc = cProcNorm(p.c) || cProceso(p.c);
      var procTag = proc
        ? '<span class="csb-rc__proc' + (isNatural(p.c) ? ' is-natural' : '') + '">' + esc(proc) + '</span>'
        : '';
      var weightTag = cWeight(p.c) === 200
        ? '<span class="csb-rc__weight">Bolsa de 200 g</span>'
        : '';
      var inner =
        '<span class="csb-rc__origin">' + flagImg(p.o) + '<span>' + esc(oes) + '</span></span>' +
        '<span class="csb-rc__img">' + media + '</span>' +
        '<span class="csb-rc__name">' + esc(name) + '</span>' +
        procTag + weightTag + debugCoffeeHtml(p.c);
      var card = document.createElement('div');
      card.className = 'csb-rc' + (editable ? ' is-editable' : '') + (cAvail(p.c) ? '' : ' is-oos');
      card.style.animationDelay = (reduce ? 0 : 0.04 * i) + 's';
      if (editable) {
        card.setAttribute('data-swap', i);
        card.setAttribute('role', 'button');
        card.setAttribute('tabindex', '0');
        card.setAttribute('aria-label', 'Cambiar ' + name);
        card.innerHTML =
          '<button type="button" class="csb-rc__del" data-del="' + i + '" aria-label="Quitar ' + esc(name) + '"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
          inner +
          '<span class="csb-rc__change"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 15-6.7L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-15 6.7L3 16"/><path d="M3 21v-5h5"/></svg>Cambiar</span>';
      } else {
        card.innerHTML = (url
          ? '<a class="csb-rc__link" href="' + esc(url) + '" target="_blank" rel="noopener">' + inner + '</a>'
          : '<span class="csb-rc__link">' + inner + '</span>');
      }
      cf.appendChild(card);
    });
    if (editable) {
      for (var k = st.box.length; k < count; k++) {
        var slot = document.createElement('button');
        slot.type = 'button'; slot.className = 'csb-rc csb-rc--add'; slot.setAttribute('data-add-slot', '1');
        slot.innerHTML = '<span class="csb-rc__plus">+</span><span class="csb-rc__addlbl">Añadir café</span>';
        cf.appendChild(slot);
      }
    }
    var cnt = $('box-count'); if (cnt) cnt.textContent = st.box.length + '/' + count;
  }

  // Lectura de la caja en una línea: cuántos son de diario y cuál es el contraste.
  function renderComposition() {
    var el = $('res-composition'); if (!el) return;
    var box = st.box || [];
    if (box.length < 2) { el.innerHTML = ''; el.hidden = true; return; }
    var nat = box.filter(function (p) { return isNatural(p.c); }).length;
    var day = box.length - nat;
    var txt;
    if (nat && day) {
      txt = 'En tu selección hay <strong>' + day + (day === 1 ? ' café' : ' cafés') +
        ' con un perfil perfecto para el día a día</strong> y ' +
        (nat === 1 ? '<strong>uno para sorprenderte</strong>' : '<strong>' + nat + ' para sorprenderte</strong>') + '.';
    } else if (nat) {
      txt = 'Toda tu caja va de <strong>naturales</strong>: fruta y dulzor de principio a fin. Contraste, el justo.';
    } else {
      txt = 'Toda tu caja son <strong>cafés de diario</strong>: limpios y fáciles de acertar taza tras taza.';
    }
    el.innerHTML = txt;
    el.hidden = false;
  }

  // ---------- Mapa de lectura en el resultado (de dónde viene la caja) ----------
  // El mapa del paso 3 es un selector; este solo cuenta la historia: "hemos
  // elegido estos cafés, y vienen de aquí". No se toca.
  var worldPromise = null;
  function loadWorld() {
    if (!worldPromise) worldPromise = d3.json('https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json');
    return worldPromise;
  }
  var resMapDrawn = false;
  function boxOriginKeys() {
    return uniq((st.box || []).map(function (p) { return p.o; })).filter(function (k) { return ORIGINS[k]; });
  }
  function renderResultMap() {
    var wrap = $('res-mapbox'); if (!wrap) return;
    var keys = boxOriginKeys();
    if (!keys.length) { wrap.hidden = true; return; }
    wrap.hidden = false;

    var chips = $('res-mapchips');
    if (chips) {
      chips.innerHTML = keys.map(function (k) {
        var n = (st.box || []).filter(function (p) { return p.o === k; }).length;
        return '<span class="csb-res-mapchip">' + flagImg(k) + '<span>' + esc(ORIGINS[k].es) + '</span>' +
          (n > 1 ? '<span class="csb-res-mapchip__n">' + n + '</span>' : '') + '</span>';
      }).join('');
    }

    var host = $('res-map'); if (!host) return;
    if (typeof d3 === 'undefined' || typeof topojson === 'undefined') { host.hidden = true; return; }
    // Se dibuja una vez; en los repintados solo cambia el relleno de los países.
    if (resMapDrawn) { paintResultMap(); return; }
    resMapDrawn = true;
    var w = 880, h = 400;
    var svg = d3.select(host).append('svg')
      .attr('viewBox', '0 0 ' + w + ' ' + h)
      .attr('role', 'img')
      .attr('aria-label', 'Mapa con los orígenes de los cafés de tu caja');
    loadWorld().then(function (world) {
      var feats = topojson.feature(world, world.objects.countries).features;
      var proj = d3.geoNaturalEarth1().fitSize([w, h], { type: 'FeatureCollection', features: feats });
      resMapPaths = svg.selectAll('path').data(feats).join('path')
        .attr('d', d3.geoPath(proj))
        .attr('stroke-linejoin', 'round').attr('stroke-linecap', 'round');
      // Se lee la caja de nuevo: puede haber cambiado mientras cargaba el mapa.
      paintResultMap();
    }).catch(function () { host.hidden = true; });
  }
  var resMapPaths = null;
  function paintResultMap() {
    if (!resMapPaths) return;
    var keys = boxOriginKeys();
    function on(d) { var k = keyOf(d.properties.name); return k && keys.indexOf(k) >= 0; }
    resMapPaths
      .attr('fill', function (d) { return on(d) ? MC.sel : MC.na; })
      .attr('stroke', function (d) { return on(d) ? MC.selStroke : MC.naStroke; })
      .attr('stroke-width', function (d) { return on(d) ? 1.1 : 0.6; });
  }

  // ---------- Modal para elegir café (añadir / cambiar) ----------
  var pickerCands = [], pickerMode = null, pickerSlot = -1, pickerShowAll = false;
  // El servidor valida el coste total y el valor de toda la caja. El navegador
  // solo ordena por afinidad y stock, sin recibir costes internos.
  function poolForSwap(target, showAll) {
    var wantProc = target ? (cProcNorm(target.c) || '').toLowerCase() : '';
    var out = [];
    Object.keys(ORIGINS).forEach(function (k) {
      ORIGINS[k].c.forEach(function (c) {
        if (!cAvail(c)) return;                                   // (c) stock real
        if (!showAll && wantProc && (cProcNorm(c) || '').toLowerCase() !== wantProc) return; // (a) proceso
        out.push({ o: k, c: c });
      });
    });
    return out;
  }
  function swapTarget() {
    return (pickerMode === 'swap' && pickerSlot >= 0 && st.box[pickerSlot])
      ? st.box[pickerSlot]
      : { c: { pn: (st.proceso && st.proceso[0] && st.proceso[0] !== SURPRISE) ? st.proceso[0] : '' } };
  }
  function renderPicker() {
    var list = $('picker-list'); if (!list) return;
    var target = swapTarget();
    var wantProc = cProcNorm(target.c) || '';
    pickerCands = poolForSwap(target, pickerShowAll);
    var order = st.origins.filter(function (k) { return ORIGINS[k]; });
    pickerCands.forEach(function (p) { if (order.indexOf(p.o) < 0) order.push(p.o); });
    var groups = {};
    pickerCands.forEach(function (p, idx) { (groups[p.o] = groups[p.o] || []).push(idx); });
    var current = (pickerMode === 'swap' && pickerSlot >= 0 && st.box[pickerSlot]) ? pk(st.box[pickerSlot]) : null;
    var html = '';
    order.forEach(function (k) {
      if (!groups[k]) return;
      html += '<div class="csb-pick__org">' + flagImg(k) + '<span>' + esc(ORIGINS[k].es) + '</span></div><div class="csb-pick__grid">';
      groups[k].forEach(function (idx) {
        var p = pickerCands[idx], name = cName(p.c), img = cImg(p.c);
        var isCur = current && pk(p) === current;
        var inBox = !isCur && st.box.some(function (b) { return pk(b) === pk(p); });
        var meta = [cRoaster(p.c), cProcNorm(p.c) || cProceso(p.c), cWeight(p.c) === 200 ? 'Bolsa de 200 g' : ''].filter(Boolean).join(' · ');
        var media = img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="csb-pick__ph">' + esc(ORIGINS[k].es.slice(0, 2).toUpperCase()) + '</span>';
        html += '<button type="button" class="csb-pick__item' + (isCur ? ' is-current' : '') + '" data-pick="' + idx + '"' + (isCur ? ' aria-current="true"' : '') + '>' +
          '<span class="csb-pick__img">' + media + (isCur ? '<span class="csb-pick__badge">Actual</span>' : (inBox ? '<span class="csb-pick__badge csb-pick__badge--in">En tu caja</span>' : '')) + '</span>' +
          '<span class="csb-pick__name">' + esc(name) + '</span>' +
          (meta ? '<span class="csb-pick__meta">' + esc(meta) + '</span>' : '') +
          debugCoffeeHtml(p.c) +
          '</button>';
      });
      html += '</div>';
    });
    if (!pickerCands.length) {
      html = '<p class="csb-pick__empty">No hay cafés que encajen ahora mismo' + (wantProc && !pickerShowAll ? '. Prueba «Ver todas las opciones».' : '.') + '</p>';
    }
    var ctrl = '';
    if (wantProc) {
      ctrl = pickerShowAll
        ? '<button type="button" class="csb-pick__all" data-toggle-all="0"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/></svg>Ver solo lo más afín</button>'
        : '<button type="button" class="csb-pick__all" data-toggle-all="1"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>Ver todas las opciones</button>';
    }
    list.innerHTML = ctrl + html;
  }
  function openPicker(mode, slot) {
    pickerMode = mode; pickerSlot = (slot == null ? -1 : slot); pickerShowAll = false;
    var ttl = $('picker-title'); if (ttl) ttl.textContent = mode === 'swap' ? 'Cambia este café' : 'Añade un café a tu caja';
    var sub = $('picker-sub'); if (sub) sub.textContent = 'Te mostramos primero lo más afín a tu caja. Elige el que quieras.';
    renderPicker();
    var m = $('picker'); if (!m) return;
    m.hidden = false; requestAnimationFrame(function () { m.classList.add('is-on'); });
    var listEl = $('picker-list'); if (listEl) listEl.scrollTop = 0;
  }
  function closePicker() { var m = $('picker'); if (!m) return; m.classList.remove('is-on'); setTimeout(function () { m.hidden = true; }, 220); pickerMode = null; pickerSlot = -1; pickerShowAll = false; }
  function choosePick(idx) {
    var p = pickerCands[idx]; if (!p) return;
    // mine: lo eligió el cliente (vs. la curación inicial de Cafeshi).
    var chosen = { o: p.o, c: p.c, mine: true };
    if (pickerMode === 'swap' && pickerSlot >= 0 && pickerSlot < st.box.length) { st.box[pickerSlot] = chosen; }
    else if (!boxFull()) { st.box.push(chosen); }
    closePicker(); afterEdit();
    var n = checkNudge(chosen); if (n) showNudge(n);
  }

  // ---------- Añadir / quitar / cambiar ----------
  function afterEdit() {
    assignmentPending = false;
    serverBoxError = '';
    serverMetrics = null;
    renderBox(); renderComposition(); renderResultMap(); renderDynamicCopy(); renderResultSummary(); updateSubscribeState(); persist();
    validateCurrentBox();
  }
  function removeAt(i) { if (i >= 0 && i < st.box.length) { st.box.splice(i, 1); afterEdit(); } }

  // ---------- Avisos inteligentes (nudges) ----------
  function availFrom(k) {
    var arr = ORIGINS[k] ? ORIGINS[k].c : [];
    for (var i = 0; i < arr.length; i++) { if (cAvail(arr[i]) && !st.box.some(function (b) { return pk(b) === (k + '|' + cName(arr[i])); })) return { o: k, c: arr[i] }; }
    for (var j = 0; j < arr.length; j++) { if (cAvail(arr[j])) return { o: k, c: arr[j] }; }
    return arr.length ? { o: k, c: arr[0] } : null;
  }
  function suggestFresh(filterFn) {
    var cands = candidates().filter(filterFn);
    var fresh = cands.filter(function (p) { return !st.box.some(function (b) { return pk(b) === pk(p); }); });
    var pool = (fresh.length ? fresh : cands).slice();
    pool.sort(function (a, b) { return (cAvail(b.c) ? 1 : 0) - (cAvail(a.c) ? 1 : 0); });
    return pool[0] || null;
  }
  function nudgeObj(title, msg, replace, suggestion) { return { title: title, msg: msg, replace: replace, suggestion: suggestion }; }
  function checkNudge(added) {
    var box = st.box, count = sizeCount(st.qty) || 1;
    // a) duplicado exacto
    if (box.filter(function (p) { return pk(p) === pk(added); }).length >= 2) {
      var altD = suggestFresh(function (p) { return pk(p) !== pk(added); });
      if (altD) return nudgeObj('¡Eh, que ya lo tienes!', 'Has metido <strong>' + esc(cName(added.c)) + '</strong> dos veces. Por mí genial… pero estás aquí para descubrir, ¿no? Dale una oportunidad a otro.', added, altD);
    }
    // b) demasiados del mismo origen, habiendo elegido otros
    var oc = originCount(box);
    var domThreshold = Math.max(3, Math.ceil(count * 0.6));
    if (oc[added.o] >= domThreshold) {
      var unused = st.origins.filter(function (k) { return ORIGINS[k] && !oc[k]; });
      if (unused.length) {
        var altO = availFrom(unused[0]);
        if (altO) return nudgeObj('¡Espera!', 'Llevas <strong>' + oc[added.o] + ' cafés de ' + esc(ORIGINS[added.o].es) + '</strong>. Elegiste también <strong>' + esc(ORIGINS[unused[0]].es) + '</strong> por algo… no te quedes sin probarlo. Un café de allí te cambia la mañana entera.', added, altO);
      }
    }
    // c) toda la caja con el mismo proceso/perfil
    var procs = box.map(function (p) { return cProceso(p.c); }).filter(Boolean);
    if (box.length >= 3 && uniq(procs).length === 1 && procs.length === box.length) {
      var altP = suggestFresh(function (p) { return cProceso(p.c) && cProceso(p.c) !== procs[0]; });
      if (altP) return nudgeObj('Todo igualito, ¿eh?', 'Tu caja entera es <strong>' + esc(procs[0]) + '</strong>. No está mal… pero el café se disfruta con contraste. Mete un proceso distinto y nota el salto en taza.', added, altP);
    }
    return null;
  }

  var pendingNudge = null;
  function showNudge(n) {
    pendingNudge = n;
    $('nudge-title').innerHTML = n.title;
    $('nudge-msg').innerHTML = n.msg;
    var s = n.suggestion, oes = ORIGINS[s.o] ? ORIGINS[s.o].es : s.o;
    $('nudge-sug').innerHTML =
      '<span class="csb-nudge__sugimg">' + (cImg(s.c) ? '<img src="' + esc(cImg(s.c)) + '" alt="">' : flagImg(s.o)) + '</span>' +
      '<span class="csb-nudge__suginfo"><span class="csb-nudge__suglbl">Te propongo</span>' +
      '<span class="csb-nudge__sugname">' + esc(cName(s.c)) + '</span>' +
      '<span class="csb-nudge__sugorg">' + flagImg(s.o) + '<span>' + esc(oes) + '</span></span></span>';
    $('nudge-accept').textContent = 'Probar este';
    var m = $('nudge'); m.hidden = false;
    requestAnimationFrame(function () { m.classList.add('is-on'); });
  }
  function hideNudge() {
    var m = $('nudge'); m.classList.remove('is-on'); pendingNudge = null;
    setTimeout(function () { m.hidden = true; }, 220);
  }
  function acceptNudge() {
    if (!pendingNudge) return;
    var n = pendingNudge;
    if (n.replace) { for (var i = st.box.length - 1; i >= 0; i--) { if (pk(st.box[i]) === pk(n.replace)) { st.box.splice(i, 1); break; } } }
    if (!boxFull()) st.box.push({ o: n.suggestion.o, c: n.suggestion.c, mine: true });
    hideNudge(); afterEdit();
  }

  // Tazas y coste por taza: 250 g por bolsa de café, 12 g por taza (ajustable).
  // Se redondea hacia ABAJO: prometer 63 tazas cuando salen 62,5 es prometer de más.
  function perCupInfo(s, count, box) {
    var cro = CFG.cro || {};
    var gpc = parseInt(cro.gramsPerCup, 10) || 12;
    var gpb = parseInt(cro.gramsPerBag, 10) || 250;
    var lbl = String((s && s.label) || '').toLowerCase();
    var kgm = lbl.match(/([\d.,]+)\s*kg/);
    var selectedWeights = (box || []).map(function (pick) { return cWeight(pick.c); }).filter(function (weight) { return weight > 0; });
    var grams = kgm
      ? (parseFloat(kgm[1].replace(',', '.')) || 1) * 1000
      : (selectedWeights.length === count ? selectedWeights.reduce(function (sum, weight) { return sum + weight; }, 0) : (count || 1) * gpb);
    var cups = Math.floor(grams / gpc);
    var basePrice = parsePrice(s && s.price);
    var price = serverMetrics && serverMetrics.valid
      ? Number(serverMetrics.chargedSubscriptionPrice || serverMetrics.subscriptionPrice || basePrice)
      : basePrice;
    return { cups: cups, grams: grams, perCup: cups > 0 ? price / cups : 0 };
  }

  // ---------- Copys dinámicos (acordeones) según la caja ----------
  function renderDynamicCopy() {
    if (assignmentPending) {
      ['faq1-a', 'faq2-a', 'faq3-a'].forEach(function (id) { setPendingContent($(id)); });
      return;
    }
    var picks = st.box, s = sizeOf(st.qty) || {};
    var cro = CFG.cro || {};
    var basePrice = parsePrice(s.price);
    var price = serverMetrics && serverMetrics.valid
      ? Number(serverMetrics.chargedSubscriptionPrice || serverMetrics.subscriptionPrice || basePrice)
      : basePrice;
    var count = parseInt(s.count, 10) || 1;
    var roasters = humanList(uniq(picks.map(function (p) { return cRoaster(p.c); })));
    var boxOrigins = humanList(uniq(picks.map(function (p) { return ORIGINS[p.o] ? ORIGINS[p.o].es : p.o; })));
    var procesos = uniq(picks.map(function (p) { return cProceso(p.c); }));

    var mine = picks.filter(function (p) { return p && p.mine; }).length;
    var total = picks.length;
    var mineNote = '';
    if (mine > 0 && mine >= total) {
      mineNote = ' Aunque, siendo justos: <strong>esta caja la has montado tú</strong>. Nosotros solo pusimos el punto de partida. El gusto es tuyo, y así nos gusta.';
    } else if (mine === 1) {
      mineNote = ' Y ojo: <strong>uno lo has elegido tú</strong>. Eso ya no es nuestra caja, es la tuya.';
    } else if (mine > 1) {
      mineNote = ' Y ojo: <strong>' + mine + ' los has elegido tú</strong>. Eso ya no es nuestra caja, es la tuya.';
    }

    var f1 = $('faq1-a');
    if (f1) {
      f1.innerHTML = 'Tú nos dijiste cómo tomas el café: <strong>' + esc(typeName(st.type)) + '</strong>' +
        (boxOrigins ? ', y de dónde lo quieres: ' + esc(boxOrigins) : '') + '. ' +
        'Con eso encima de la mesa y años de cata como Q-Grader detrás, fuimos a por ' +
        (roasters ? '<strong>' + esc(roasters) + '</strong>' : 'estos cafés') + '. ' +
        'Son cafés que dan lo mejor de sí por su proceso' +
        (procesos.length ? ' (' + esc(humanList(procesos)) + ')' : '') + ' y en tu método. ' +
        'La idea es sencilla: que ninguna mañana del mes te sepa igual.' + mineNote;
    }
    var f2 = $('faq2-a');
    if (f2) {
      f2.innerHTML = 'No es al azar, y no es "el más caro gana". Primero comprobamos stock, evitamos repeticiones y descartamos descafeinados si no los has pedido. ' +
        'Después verificamos que la caja mantenga el ahorro prometido frente a comprar los cafés sueltos. ' +
        'Entre las combinaciones válidas priorizamos tu <strong>' + esc(typeName(st.type)) + '</strong>, proceso, tostadores y orígenes' +
        (boxOrigins ? ' (' + esc(boxOrigins) + ')' : '') + ', equilibrando variedad y perfiles.';
    }
    var sv = $('res-savings');
    if (sv) {
      var pc = perCupInfo(s, count, st.box), cups = pc.cups, perCup = pc.perCup;
      var cafeOut = cro.cafeOut || '2,5–3 €';
      sv.innerHTML = '<p class="csb-save-intro">Mucho más que café. Si lo eliges tú cada mes, acabas comprando siempre lo mismo (o lo que pilla). Aquí no:</p>' +
        '<ul class="csb-faq-list">' +
        '<li><strong>Descubres</strong>: este mes, ' + (roasters ? esc(roasters) : 'tostadores de primera') + (boxOrigins ? ' de ' + esc(boxOrigins) : '') + '. Cafés que seguramente no comprarías por tu cuenta.</li>' +
        '<li><strong>Tú mandas</strong>: te proponemos la caja catada por Q-Graders, pero la ajustas a tu gusto en un clic.</li>' +
        '<li><strong>Recién tostado</strong>: lotes pequeños, no el café de hace meses del estante.</li>' +
        '<li><strong>A tu puerta</strong>: ' + (CFG.isSpain ? 'envío incluido en España' : 'envío calculado según el destino') + ', y lo pausas o cancelas cuando quieras.</li>' +
        '</ul>' +
        '<p class="csb-save-total">' +
        (serverMetrics && serverMetrics.valid && Number(serverMetrics.totalSavings || 0) > 0 ? (CFG.isSpain ? 'Comprados por separado, estos cafés más el envío suman ' : 'Comprados por separado, estos cafés suman ') + '<strong>' + formatEur(Number(serverMetrics.comparisonTotal || 0)) + '</strong>. Con la suscripción tienes un ahorro total de <strong>' + formatEur(Number(serverMetrics.totalSavings || 0)) + ' (' + String(Number(serverMetrics.totalSavingsPercent || 0)).replace('.', ',') + '%)</strong>. ' : '') +
        (cups > 0 ? 'Y la cuenta que de verdad importa: ' + pc.grams + ' g de café de especialidad, unas <strong>' + cups + ' tazas</strong> por ' + money(price) + ' → <strong>≈ ' + formatEur(perCup) + ' la taza</strong>. Ese mismo café, en una cafetería, te cuesta ' + esc(cafeOut) + '. '
          : 'Café de especialidad recién tostado, cada mes, por el precio de un café fuera. ') +
        'Tú eliges: el de siempre, o una cata distinta cada mes.</p>';
    }
  }

  function updateSubscribeState() {
    var count = sizeCount(st.qty) || 1;
    var full = st.box.length === count;
    var financiallyValid = !!(serverMetrics && serverMetrics.valid);
    var sub = $('subscribe');
    var canWait = assignmentPending && serverBoxReady && !serverBoxError && st.boxSig === boxSig();
    sub.disabled = boxValidationPending || !(canWait || (full && financiallyValid));
    sub.textContent = canWait ? CFG.pendingButton : CFG.subscribeLabel;
    sub.style.opacity = sub.disabled ? '.5' : '';
    var note = $('box-note');
    if (note) {
      var missing = count - st.box.length;
      if (boxValidationPending) { note.hidden = false; note.textContent = 'Comprobando disponibilidad y valor de la selección.'; }
      else if (canWait) {
        note.textContent = CFG.pendingCheckoutNote || '';
        note.hidden = !note.textContent;
      }
      else if (full && serverBoxError) { note.hidden = false; note.textContent = serverBoxError; }
      else if (full || missing <= 0) { note.hidden = true; }
      else { note.hidden = false; note.textContent = 'Te ' + (missing === 1 ? 'falta 1 café' : ('faltan ' + missing + ' cafés')) + ' para completar tu caja.'; }
    }
  }

  function renderResultSummary() {
    var s = sizeOf(st.qty) || {};
    var cro = CFG.cro || {};
    var basePrice = parsePrice(s.price);
    var price = serverMetrics && serverMetrics.valid
      ? Number(serverMetrics.chargedSubscriptionPrice || serverMetrics.subscriptionPrice || basePrice)
      : basePrice;
    var count = parseInt(s.count, 10) || 1;
    var pcSum = perCupInfo(s, count, st.box);
    var extras = (!assignmentPending && pcSum.cups > 0 && cro.showPerUnit !== false)
      ? '<div class="csb-summary__extra"><span class="csb-summary__per">' + esc(String(pcSum.cups)) + ' tazas · ≈ ' + formatEur(pcSum.perCup) + ' ' + ((cro.perUnitSuffix && cro.perUnitSuffix.indexOf('caf') < 0) ? cro.perUnitSuffix : 'la taza') + '</span></div>'
      : '';
    var shipVal = parsePrice(cro.shipValue);
    var shipRow = CFG.isSpain
      ? '<div class="csb-row csb-row--ship"><span class="csb-t">' + esc(CFG.shipIncludedLabel || 'Envío incluido en España') + '</span>' +
        '<span class="csb-p csb-p--was">' + (shipVal > 0 ? '<s>' + formatEur(shipVal) + '</s>' : '0 €') + '</span></div>'
      : '<div class="csb-row csb-row--ship"><span class="csb-t">Envío fuera de España</span><span class="csb-p">Calculado en checkout</span></div>';
    var loose = serverMetrics && serverMetrics.valid
      ? Number(serverMetrics.pvpTotal || 0)
      : (st.box || []).reduce(function (sum, pick) { return sum + cPrice(pick.c); }, 0);
    var comparison = serverMetrics && serverMetrics.valid
      ? Number(serverMetrics.comparisonTotal || 0)
      : loose + (CFG.isSpain ? shipVal : 0);
    var saving = serverMetrics && serverMetrics.valid
      ? Number(serverMetrics.totalSavings || 0)
      : Math.max(0, comparison - price);
    var shippingSaving = CFG.isSpain ? Math.min(shipVal, saving) : 0;
    var coffeeSaving = Math.max(0, saving - shippingSaving);
    var looseComparisonRow = loose > 0
      ? '<div class="csb-row csb-row--saving-detail"><span class="csb-t">Valor de estos cafés comprados sueltos</span><span class="csb-p">' + formatEur(loose) + '</span></div>'
      : '';
    var costSurcharge = serverMetrics && serverMetrics.valid ? Number(serverMetrics.costSurcharge || 0) : 0;
    var surchargeInfo = '<span class="csb-info-tip">' +
      '<button class="csb-info-tip__button" type="button" aria-label="Por qué se aplica este suplemento" aria-describedby="csb-surcharge-tooltip">' +
      '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="8.25"></circle><path d="M10 8.7v5M10 5.8h.01"></path></svg>' +
      '</button>' +
      '<span class="csb-info-tip__content" id="csb-surcharge-tooltip" role="tooltip">Tu selección incluye cafés cuyo valor conjunto supera el incluido en el precio base. Solo se añade la diferencia correspondiente.</span>' +
      '</span>';
    var surchargeRow = costSurcharge > 0
      ? '<div class="csb-row csb-row--value"><span class="csb-t">Precio base</span><span class="csb-p">' + formatEur(basePrice) + '</span></div>' +
        '<div class="csb-row csb-row--value"><span class="csb-t csb-surcharge-label">Suplemento por esta selección ' + surchargeInfo + '</span><span class="csb-p">' + formatEur(costSurcharge) + '</span></div>'
      : '';
    var savingRow = loose > 0 && saving > 0
      ? '<div class="csb-saving-breakdown">' +
        '<div class="csb-row csb-row--saving"><span class="csb-t"><strong>Estás ahorrando</strong></span><span class="csb-p"><strong>' + formatEur(saving) + '</strong></span></div>' +
        '<div class="csb-saving-breakdown__items">' +
        looseComparisonRow +
        '<div class="csb-row csb-row--saving-detail"><span class="csb-t">Ahorro en los cafés</span><span class="csb-p">' + formatEur(coffeeSaving) + '</span></div>' +
        (CFG.isSpain ? '<div class="csb-row csb-row--saving-detail"><span class="csb-t">Envío incluido</span><span class="csb-p">' + formatEur(shippingSaving) + '</span></div>' : '') +
        '</div></div>'
      : '';
    $('res-summary').innerHTML =
      '<div class="csb-row"><span class="csb-t">' + typeName(st.type) + ' · ' + esc(String(s.label || '').replace(/(\d+)\s*caf[eé]s?/i, '$1 bolsas')) + '</span>' +
      '<span class="csb-p">' + formatEur(price) + '<small>' + priceSuffix() + '</small></span></div>' + extras + surchargeRow + (CFG.isSpain ? '' : shipRow) + savingRow;
  }

  function renderResult() {
    var t = typeById(st.type);
    var s = sizeOf(st.qty) || {};
    ensureBox();
    var isKilo = isKiloSelection();
    var cro = CFG.cro || {};

    // ---- Cabecera ----
    // El título es siempre el nombre de la LÍNEA, no el método: lo que contrata
    // el cliente es "Suscripción Cafeshi Kaori", no "una caja de filtro".
    $('res-title').textContent = 'Tu suscripción ' + lineName(st.type);
    if (isKilo) {
      $('res-sub').textContent = (s.label || '') + ' a la medida de tu máquina, renovado cada mes.';
    } else if (t && !t.hasOrigins && t.description) {
      $('res-sub').textContent = t.description;
    } else if (st.route === 'guided') {
      $('res-sub').textContent = CFG.guidedResultSub || 'Cada mes te seleccionamos cafés frescos que encajan con cómo lo preparas en casa. Si alguno no te convence, lo cambias. Sin permanencia.';
    } else {
      $('res-sub').textContent = 'Seleccionada a partir de tus orígenes: ' + st.origins.map(function (k) { return ORIGINS[k] ? ORIGINS[k].es : k; }).join(', ') + '. Ajústala a tu gusto.';
    }

    // ---- Caja editable + lectura (composición y mapa de orígenes) ----
    renderBox();
    renderComposition();
    renderResultMap();
    var resultNote = $('res-note'); if (resultNote) resultNote.hidden = assignmentPending;
    var faqs = $('faqs'); if (faqs) faqs.hidden = assignmentPending;

    // ---- Etiqueta oculta: duplicaba los beneficios de abajo (envío gratis / sin permanencia). ----
    var tag = $('res-savetag');
    if (tag) { tag.hidden = true; }

    renderResultSummary();

    // ---- Beneficios ----
    var benefits = (cro.benefits || []).filter(Boolean).map(function (benefit) {
      if (!CFG.isSpain && /env[ií]o\s+gratis|env[ií]o\s+incluido/i.test(benefit)) return 'Envío calculado según el destino';
      if (/env[ií]o\s+(gratis|incluido)/i.test(benefit)) {
        return CFG.isSpain ? 'Envío incluido en España' : 'Envío calculado según el destino';
      }
      return benefit;
    });
    var bHtml = benefits.map(function (txt, i) {
      return '<li>' + (BENEFIT_ICONS[i] || BENEFIT_FALLBACK) + '<span>' + txt + '</span></li>';
    }).join('');
    bHtml += '<li>' + BENEFIT_FALLBACK + '<span>Curado por Q-Graders: origen, perfil y temporada.</span></li>';
    $('res-benefits').innerHTML = bHtml;

    // ---- Fecha de cobro (navegador del cliente) ----
    var months = st.freq === 'bimestral' ? 2 : 1;
    var next = addMonths(new Date(), months);
    if (assignmentPending) {
      $('res-charge').textContent = CFG.pendingChargeMessage || '';
    } else {
      $('res-charge').innerHTML = 'Primer cobro hoy, <strong>' + fmtDate(new Date()) + '</strong>. Se renueva el <strong>' + fmtDate(next) + '</strong>.';
    }

    // ---- Copys dinámicos + estado del botón ----
    renderDynamicCopy();
    updateSubscribeState();
    $('res-confirm').classList.remove('is-on');
  }

  // Suscribirme → /cart/add.js con la variante (Tipo|Tamaño) + selling_plan (Seal) +
  // properties Origen 1/2/3. Si aún no hay producto/plan (no publicado o sin Seal),
  // cae al aviso del prototipo sin romper nada.
  function submitSelection(btn, options) {
    options = options || {};
    var selectedExtra = options.selectedExtra || null;
    var variantId = subscriptionVariantId();
    var plan = pickPlan(st.freq);
    if (!variantId || !plan) {
      var setupError = $('res-confirm');
      var setupMessage = setupError && setupError.querySelector('span');
      if (setupMessage) setupMessage.textContent = !variantId
        ? 'No encontramos la variante de esta caja. Recarga la página o contacta con Cafeshi.'
        : 'No encontramos la frecuencia de suscripción. Recarga la página o contacta con Cafeshi.';
      if (setupError) setupError.classList.add('is-on');
      btn.disabled = false;
      btn.style.opacity = '';
      return;
    }
    // Preferencias guardadas en la suscripción (spec §5.4): ruta, método, perfil/proceso
    // y los cafés finales de la caja (curados + swaps). Mismo SKU; solo cambian props.
    var tsel = typeById(st.type);
    var isKiloSel = isKiloSelection();
    var subscriptionBundleId = 'cafeshi-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    var props = {};
    if (!isKiloSel) {
      props['_subscription_box_size'] = String(sizeCount(st.qty));
    }
    if (assignmentPending && !isKiloSel) {
      props['_subscription_assignment_pending'] = '1';
      props[CFG.pendingPropertyLabel] = CFG.pendingPropertyValue;
    }
    props['_subscription_bundle_id'] = subscriptionBundleId;
    props['_subscription_role'] = 'main';
    props['Ruta'] = st.route === 'expert' ? 'Experta' : 'Guiada';
    if (tsel) props['Método'] = typeName(st.type);
    if (st.route === 'expert' && st.proceso && st.proceso.length) {
      props['Proceso'] = st.proceso[0] === SURPRISE ? 'Sorpréndeme' : st.proceso.join(', ');
    }
    if (st.route === 'expert' && st.roasters && st.roasters.length) props['Tostadores'] = st.roasters.join(', ');
    props['_subscription_origins'] = JSON.stringify(st.origins || []);
    if (!isKiloSel && st.box && st.box.length) {
      st.box.forEach(function (p, i) {
        props['Café ' + (i + 1)] = cName(p.c) + ' · ' + (ORIGINS[p.o] ? ORIGINS[p.o].es : p.o) + (cWeight(p.c) ? ' · ' + cWeight(p.c) + ' g' : '');
        props['_coffee_' + (i + 1) + '_handle'] = cHandle(p.c);
        props['_coffee_' + (i + 1) + '_variant_id'] = cVariantId(p.c);
      });
      props['Valor cafés sueltos'] = formatEur(Number(serverMetrics.pvpTotal || 0));
      props['Envío compra suelta'] = formatEur(Number(serverMetrics.looseShipping || 0));
      props['Ahorro total'] = formatEur(Number(serverMetrics.totalSavings || 0));
      props['Peso total caja'] = String(Number(serverMetrics.totalWeightGrams || 0)) + ' g';
      props['Precio base suscripción'] = formatEur(Number(serverMetrics.baseSubscriptionPrice || 0));
      props['Suplemento selección'] = formatEur(Number(serverMetrics.costSurcharge || 0));
      props['Precio renovación'] = formatEur(Number(serverMetrics.chargedSubscriptionPrice || serverMetrics.subscriptionPrice || 0));
    } else if (isKiloSel && st.box && st.box.length) {
      props['Café recomendado'] = cName(st.box[0].c) + ' · 1 kg';
      props['_coffee_1_handle'] = cHandle(st.box[0].c);
      props['_coffee_1_variant_id'] = cVariantId(st.box[0].c);
      props['Peso total'] = '1000 g';
    }
    btn.disabled = true; btn.style.opacity = '.7';
    var items = [{ id: String(variantId), quantity: 1, selling_plan: String(plan), properties: props }];
    var surchargeCents = !isKiloSel && serverMetrics && serverMetrics.valid
      ? Math.round(Number(serverMetrics.costSurcharge || 0) * 100)
      : 0;
    if (surchargeCents > 0) {
      var surchargeVariantId = SUB.surchargeVariants[String(surchargeCents)];
      if (!surchargeVariantId) {
        var surchargeError = $('res-confirm');
        var surchargeMessage = surchargeError && surchargeError.querySelector('span');
        if (surchargeMessage) surchargeMessage.textContent = 'No hemos podido aplicar el suplemento de esta selección. Prueba otra combinación o contacta con Cafeshi.';
        if (surchargeError) surchargeError.classList.add('is-on');
        btn.disabled = false;
        btn.style.opacity = '';
        return;
      }
      items.push({
        id: String(surchargeVariantId),
        quantity: 1,
        properties: {
          '_subscription_bundle_id': subscriptionBundleId,
          '_subscription_role': 'surcharge',
          'Ajuste de la caja': 'Suplemento por selección',
          'Importe': formatEur(Number(serverMetrics.costSurcharge || 0))
        }
      });
    }
    if (selectedExtra && selectedExtra.id) {
      items.push({
        id: String(selectedExtra.id),
        quantity: 1,
        properties: { 'Extra de suscripción': selectedExtra.kind || 'Extra seleccionado' }
      });
    }
    root.querySelectorAll('[data-addon-variant]:checked').forEach(function (addon) {
      if (selectedExtra) return;
      var addonKind = addon.getAttribute('data-addon-kind') || 'Sí';
      items.push({
        id: String(addon.getAttribute('data-addon-variant')),
        quantity: 1,
        properties: { 'Extra de suscripción': addonKind }
      });
    });
    var shippingCode = '';
    fetch('/apps/cafeshi-suscripcion/shipping-code', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ bundleId: subscriptionBundleId })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (payload) {
        if (!r.ok || !payload.ok || !payload.code) {
          throw new Error(payload.error || 'No se ha podido activar el envío incluido.');
        }
        shippingCode = String(payload.code);
        props['_subscription_shipping_discount'] = shippingCode;
      });
    }).then(function () {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }).then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (payload) {
        throw new Error(payload.description || payload.message || 'No se ha podido añadir la suscripción.');
      });
      clearSaved();
      window.location.href = '/checkout?discount=' + encodeURIComponent(shippingCode);
    }).catch(function (error) {
      btn.disabled = false;
      btn.style.opacity = '';
      var cartError = $('res-confirm');
      var cartMessage = cartError && cartError.querySelector('span');
      if (cartMessage) cartMessage.textContent = error && error.message
        ? error.message
        : 'No se ha podido añadir la suscripción. Inténtalo de nuevo.';
      if (cartError) cartError.classList.add('is-on');
    });
  }
  function startSubmission(btn, options) {
    if (!isEditable()) { submitSelection(btn, options); return; }
    btn.disabled = true;
    validateCurrentBox().then(function (valid) {
      if (valid) submitSelection(btn, options);
      else btn.disabled = false;
    }).catch(function () {
      btn.disabled = false;
    });
  }
  $('subscribe').onclick = function () {
    startSubmission(this, {});
  };
  var browseAddonsBtn = $('addons-browse');
  root.querySelectorAll('[data-addon-variant]').forEach(function (addon) {
    addon.addEventListener('change', function () {
      if (!addon.checked) return;
      root.querySelectorAll('[data-addon-variant]').forEach(function (otherAddon) {
        if (otherAddon !== addon) otherAddon.checked = false;
      });
    });
  });
  var addonsModal = $('addons-modal');
  var addonsModalClose = $('addons-modal-close');
  var addonsModalGrid = $('addons-modal-grid');
  var addonsModalState = $('addons-modal-state');
  var addonsModalAdd = $('addons-modal-add');
  var addonsModalLoaded = false;
  var selectedModalExtra = null;
  var addonsModalOpener = null;

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function modalMoney(value) {
    var amount = Number(value || 0);
    try {
      return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(amount);
    } catch (error) {
      return amount.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function selectModalExtra(button) {
    addonsModalGrid.querySelectorAll('[data-modal-variant]').forEach(function (card) {
      var isSelected = card === button;
      card.classList.toggle('is-selected', isSelected);
      card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
    selectedModalExtra = {
      id: button.getAttribute('data-modal-variant'),
      kind: button.getAttribute('data-modal-title') || 'Extra seleccionado'
    };
    addonsModalAdd.disabled = false;
  }

  function renderModalProducts(products) {
    var excluded = String(browseAddonsBtn.getAttribute('data-exclude-variants') || '').split(',');
    var cards = [];
    (products || []).forEach(function (product) {
      if (product.handle === 'suscripcion-cafeshi-1') return;
      var variant = (product.variants || []).find(function (item) {
        return item.available && excluded.indexOf(String(item.id)) < 0;
      });
      if (!variant || cards.length >= 18) return;
      var originalPrice = Number(variant.price || 0);
      var subscriberPrice = originalPrice * 0.85;
      var imageData = (product.images && product.images[0]) || product.featured_image || '';
      var image = typeof imageData === 'string' ? imageData : (imageData.src || '');
      var variantLabel = variant.title && variant.title !== 'Default Title' ? variant.title : '';
      cards.push(
        '<button type="button" class="csb-modal-product" aria-pressed="false"' +
          ' data-modal-variant="' + escapeHtml(variant.id) + '" data-modal-title="' + escapeHtml(product.title) + '">' +
          '<span class="csb-modal-product__media">' + (image ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="csb-modal-product__body">' +
            '<span class="csb-modal-product__offer">Tu precio de suscriptor</span>' +
            '<strong>' + escapeHtml(product.title) + '</strong>' +
            (variantLabel ? '<span class="csb-modal-product__variant">' + escapeHtml(variantLabel) + '</span>' : '') +
            '<span class="csb-modal-product__price"><s>' + modalMoney(originalPrice) + '</s><b>' + modalMoney(subscriberPrice) + '</b></span>' +
          '</span>' +
          '<span class="csb-modal-product__check" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12l4 4 10-10"/></svg></span>' +
        '</button>'
      );
    });
    addonsModalGrid.innerHTML = cards.join('');
    addonsModalState.hidden = cards.length > 0;
    addonsModalState.textContent = cards.length ? '' : 'Ahora mismo no hay más opciones disponibles.';
    addonsModalGrid.querySelectorAll('[data-modal-variant]').forEach(function (card) {
      card.onclick = function () { selectModalExtra(card); };
    });
  }

  function loadModalProducts() {
    if (addonsModalLoaded) return Promise.resolve();
    addonsModalState.hidden = false;
    addonsModalState.textContent = 'Preparando más opciones...';
    return fetch(browseAddonsBtn.getAttribute('data-products-url'), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('No se han podido cargar las opciones.');
        return response.json();
      })
      .then(function (payload) {
        renderModalProducts(payload.products || []);
        addonsModalLoaded = true;
      })
      .catch(function () {
        addonsModalState.hidden = false;
        addonsModalState.textContent = 'No hemos podido cargar las opciones. Cierra y vuelve a intentarlo.';
      });
  }

  function closeAddonsModal() {
    if (addonsModal && addonsModal.open) addonsModal.close();
    document.body.classList.remove('csb-addons-modal-open');
    if (addonsModalOpener) addonsModalOpener.focus();
  }

  if (browseAddonsBtn && addonsModal) browseAddonsBtn.onclick = function () {
    addonsModalOpener = this;
    selectedModalExtra = null;
    addonsModalAdd.disabled = true;
    document.body.classList.add('csb-addons-modal-open');
    addonsModal.showModal();
    addonsModalClose.focus();
    loadModalProducts();
  };
  if (addonsModalClose) addonsModalClose.onclick = closeAddonsModal;
  if (addonsModal) {
    addonsModal.addEventListener('click', function (event) {
      if (event.target === addonsModal) closeAddonsModal();
    });
    addonsModal.addEventListener('close', function () {
      document.body.classList.remove('csb-addons-modal-open');
      if (addonsModalOpener) addonsModalOpener.focus();
    });
  }
  if (addonsModalAdd) addonsModalAdd.onclick = function () {
    if (!selectedModalExtra) return;
    root.querySelectorAll('[data-addon-variant]:checked').forEach(function (addon) { addon.checked = false; });
    closeAddonsModal();
    startSubmission(this, { selectedExtra: selectedModalExtra });
  };
  $('restart').onclick = function () { clearSaved(); st = blankState(); paintTypes(); show('entry'); };

  // Pantalla de entrada: elegir ruta (guiada / experta) → mismo flujo, distinto camino.
  function setupRoutes() {
    root.querySelectorAll('.csb-route[data-route]').forEach(function (b) {
      b.onclick = function () {
        var route = b.getAttribute('data-route');
        // Cambiar de ruta invalida toda la selección previa: los pasos no son los mismos.
        st = blankState(); st.route = route;
        paintTypes();
        show('type');
      };
    });
  }

  // ---- Editor de caja (Paso 5): delegación de eventos ----
  (function () {
    var cf = $('res-coffees');
    if (cf) {
      cf.addEventListener('click', function (e) {
        var del = e.target.closest && e.target.closest('[data-del]');
        if (del) { e.preventDefault(); e.stopPropagation(); removeAt(parseInt(del.getAttribute('data-del'), 10)); return; }
        var sw = e.target.closest && e.target.closest('[data-swap]');
        if (sw) { e.preventDefault(); openPicker('swap', parseInt(sw.getAttribute('data-swap'), 10)); return; }
        var slot = e.target.closest && e.target.closest('[data-add-slot]');
        if (slot) { e.preventDefault(); openPicker('add', -1); }
      });
      cf.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var sw = e.target.closest && e.target.closest('[data-swap]');
        if (sw) { e.preventDefault(); openPicker('swap', parseInt(sw.getAttribute('data-swap'), 10)); }
      });
    }
    var pl = $('picker-list');
    if (pl) pl.addEventListener('click', function (e) {
      var toggle = e.target.closest && e.target.closest('[data-toggle-all]');
      if (toggle) { e.preventDefault(); pickerShowAll = toggle.getAttribute('data-toggle-all') === '1'; renderPicker(); return; }
      var it = e.target.closest && e.target.closest('[data-pick]');
      if (it) { e.preventDefault(); choosePick(parseInt(it.getAttribute('data-pick'), 10)); }
    });
    root.querySelectorAll('[data-picker-close]').forEach(function (b) { b.onclick = closePicker; });
    var na = $('nudge-accept'); if (na) na.onclick = acceptNudge;
    var nk = $('nudge-keep'); if (nk) nk.onclick = hideNudge;
    root.querySelectorAll('[data-nudge-close]').forEach(function (b) { b.onclick = hideNudge; });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (pendingNudge) hideNudge();
      else if ($('picker') && !$('picker').hidden) closePicker();
    });
  })();

  root.querySelectorAll('#csb-freq-ctrl .csb-seg-btn').forEach(function (b) {
    // Re-pinta las tarjetas: el precio lleva la cadencia dentro y tiene que cambiar con ella.
    b.onclick = function () { st.freq = b.getAttribute('data-freq'); renderQty(); persist(); };
  });
  $('qty-go').onclick = function () {
    var t = typeById(st.type); if (!t || !st.qty) return;
    if (st.route === 'expert' && t.hasOrigins) { renderOriginsStep(); show('origins'); } else { show('search'); }
  };
  // Tras los orígenes viene el tostador (último filtro, y opcional).
  $('org-go').onclick = function () { if (st.origins.length === REQUIRED) { renderRoasters(); show('roaster'); } };
  root.querySelectorAll('[data-back]').forEach(function (b) {
    b.onclick = function () { show(b.getAttribute('data-back')); };
  });

  // Restaura el progreso guardado (si lo hay), saltando pasos transitorios.
  function bootFromSaved() {
    var saved = readSaved();
    if (!saved || !saved.st) return false;
    st.route = (saved.st.route === 'guided' || saved.st.route === 'expert') ? saved.st.route : null;
    if (!st.route || !saved.st.type) return false;
    var t = typeById(saved.st.type);
    if (!t) { clearSaved(); return false; }

    st.type = saved.st.type;
    var savedQty = saved.st.qty;
    st.qty = (savedQty && t.sizes.indexOf(savedQty) >= 0) ? savedQty : defaultQty(t);
    st.freq = saved.st.freq === 'bimestral' ? 'bimestral' : 'mensual';
    st.origins = Array.isArray(saved.st.origins)
      ? saved.st.origins.filter(function (k) { return ORIGINS[k]; }).slice(0, REQUIRED)
      : [];
    // Restaura la caja editada (ensureBox la valida/regenera si la selección cambió).
    var VALID_PROC = { Lavado: 1, Natural: 1, Honey: 1 };
    VALID_PROC[SURPRISE] = 1;
    st.proceso = Array.isArray(saved.st.proceso) ? saved.st.proceso.filter(function (p) { return VALID_PROC[p]; }) : [];
    st.roasters = Array.isArray(saved.st.roasters) ? saved.st.roasters.filter(function (r) { return typeof r === 'string'; }) : [];
    st.box = Array.isArray(saved.st.box) ? saved.st.box : null;
    st.boxSig = typeof saved.st.boxSig === 'string' ? saved.st.boxSig : null;
    paintTypes();

    var step = saved.step || 'type';
    if (t.sizes.length > 1) renderQty();

    if (st.route === 'guided') {
      // La guiada ya no tiene proceso, orígenes ni tostador: esos pasos no existen.
      if (step === 'proceso' || step === 'origins' || step === 'roaster') step = 'result';
      if (step === 'qty' && t.sizes.length <= 1) step = 'result';
    } else {
      paintProceso();
      if (!st.proceso.length && step !== 'type') step = 'proceso';
      if (step !== 'proceso') {
        if (t.hasOrigins) {
          if ((step === 'roaster' || step === 'result') && st.origins.length !== REQUIRED) step = 'origins';
          if (step === 'origins' || step === 'roaster' || step === 'result') renderOriginsStep();
          if (step === 'roaster') renderRoasters();
        } else if (step === 'origins' || step === 'roaster') {
          step = 'result';
        }
        if (step === 'qty' && t.sizes.length <= 1) step = t.hasOrigins ? 'origins' : 'result';
      }
    }

    if (step === 'result' && t.hasOrigins) {
      var savedBox = Array.isArray(st.box) ? st.box : [];
      if (savedBox.length !== sizeCount(st.qty) || savedBox.some(function (pick) { return !cHandle(pick.c); })) step = 'search';
    }
    if (step === 'result' && !t.hasOrigins) step = 'search';

    show(step);
    if (step === 'result' && t.hasOrigins) validateCurrentBox();
    return true;
  }

  function bootSurchargeDemo() {
    if (!SURCHARGE_DEMO) return false;
    var demoHandles = [
      'jaleo-colombia-hugo-gualaco-rosado',
      'eth-006-elto-elora',
      'parcel-etiopia-e-006',
      'poma-coffee-research-colombia-san-sebastian-castillo',
      'poma-coffee-research-colombia-las-brisas-bourbon-aji',
      'jaleo-colombia-aruzi-satus'
    ];
    var demoType = TYPES.find(function (type) {
      return type.hasOrigins && type.sizes.indexOf('6') >= 0 && /mezcla/i.test(type.name);
    }) || TYPES.find(function (type) {
      return type.hasOrigins && type.sizes.indexOf('6') >= 0;
    });
    if (!demoType) return false;

    clearSaved();
    st = blankState();
    st.route = 'expert';
    st.type = demoType.id;
    st.proceso = [SURPRISE];
    st.qty = '6';
    st.freq = 'bimestral';
    st.origins = DEFAULTS.slice(0, REQUIRED);
    paintTypes();
    paintProceso();
    renderQty();
    root.setAttribute('data-surcharge-demo-status', 'loading');
    show('entry');

    recommendationRequest('validate', demoHandles).then(function (payload) {
      applyServerOptions(payload.options || payload.coffees || []);
      var box = demoHandles.map(pairByHandle).filter(Boolean);
      if (box.length !== demoHandles.length) throw new Error('La caja de demostración ya no está disponible.');
      st.box = box;
      st.boxSig = boxSig();
      assignmentPending = false;
      serverMetrics = payload.metrics || null;
      if (!(serverMetrics && serverMetrics.valid)) throw new Error('La caja de demostración ya no está disponible.');
      serverBoxReady = true;
      serverBoxError = '';
      root.setAttribute('data-surcharge-demo-status', 'ready');
      show('result');
    }).catch(function (error) {
      root.setAttribute('data-surcharge-demo-status', 'error');
      if (DEBUG_MODE) root.setAttribute('data-surcharge-demo-error', error && error.message ? error.message : 'unknown');
      serverMetrics = null;
      serverBoxReady = false;
      serverBoxError = '';
      st = blankState();
      paintTypes();
      show('entry');
    });
    return true;
  }

  setupTypes(); paintTypes(); setupRoutes(); setupProceso(); setupRoasters();
  if (SURCHARGE_DEMO) {
    if (!bootSurchargeDemo()) show('entry');
  } else if (!bootFromSaved()) show('entry');
  booted = true;
})();
